var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 166 109.8",
    style: {
      enableBackground: "new 0 0 166 109.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M9.1,6L9,6C6.6,6.7,5.6,9.7,5.6,9.9l0,0.1l0,0.1c0,0.8,0.9,79.6,1.1,86.3c0.1,2.7,0.8,4.6,2.1,5.6 c0.8,0.6,1.6,0.7,2.1,0.7c0.3,0,0.5,0,0.5,0h142.3c4.8,0,5.1-4.4,5.1-4.4c0-0.8,1.8-81.9,1.6-86.8c-0.2-4.6-2.9-4.9-5.3-5.2 c-0.4,0-0.8-0.1-1.2-0.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626"
    },
    d: "M36,81.2l-5.2,21.5c0,0,0,0.7,1.8,0.7c1.8,0,101.5,0.5,101.9,0s0.2-0.7-0.5-4.1 c-0.7-3.4-3.6-18.1-3.6-18.1s0-0.7-1.6-0.7c-1.6,0-92.4,0.2-92.4,0.2S36.2,80.8,36,81.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCF9EE"
    },
    points: "145.9,12.8 19.7,12.8 12.9,19.8 12.9,77.1 151.7,77.1 152.4,37.2 152.6,19.8 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F49C1C"
    },
    points: "152.4,37.2 151.7,77.1 12.9,77.1 12.9,35.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M152.1,77.5H12.5v-42l140.3,1.3L152.1,77.5z M13.2,76.8h138.1l0.6-39.2L13.2,36.3V76.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "152.4,37.2 151.7,77.1 12.9,77.1 12.9,35.9  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "alphtone-texture_4_",
    style: {
      display: "none",
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 53.2283 172.3338)",
    style: {
      fill: "#141414"
    },
    cx: 197.7,
    cy: 33.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 49.3484 171.6634)",
    style: {
      fill: "#141414"
    },
    cx: 195.1,
    cy: 36.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 45.4685 170.9929)",
    style: {
      fill: "#141414"
    },
    cx: 192.5,
    cy: 40.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 41.5886 170.3224)",
    style: {
      fill: "#141414"
    },
    cx: 189.9,
    cy: 43.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 37.7087 169.652)",
    style: {
      fill: "#141414"
    },
    cx: 187.3,
    cy: 47.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 33.8288 168.9815)",
    style: {
      fill: "#141414"
    },
    cx: 184.7,
    cy: 50.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 29.9489 168.311)",
    style: {
      fill: "#141414"
    },
    cx: 182.1,
    cy: 54.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 26.069 167.6406)",
    style: {
      fill: "#141414"
    },
    cx: 179.5,
    cy: 57.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M175.3,60.3c-0.6,0.9-0.5,2.1,0.4,2.7s2.1,0.5,2.7-0.4c0.6-0.9,0.5-2.1-0.4-2.7 C177.2,59.3,175.9,59.4,175.3,60.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M172.8,63.9c-0.6,0.8-0.4,1.9,0.4,2.5s1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 C174.5,62.9,173.4,63.1,172.8,63.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M170.3,67.5c-0.6,0.8-0.4,1.8,0.4,2.4c0.8,0.6,1.8,0.4,2.4-0.4c0.6-0.8,0.4-1.8-0.4-2.4 C171.9,66.6,170.8,66.7,170.3,67.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M167.8,71.1c-0.5,0.7-0.4,1.7,0.3,2.2c0.7,0.5,1.7,0.4,2.2-0.3c0.5-0.7,0.4-1.7-0.3-2.2 C169.3,70.2,168.3,70.3,167.8,71.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M165.2,74.6c-0.5,0.7-0.4,1.6,0.3,2.1c0.7,0.5,1.6,0.4,2.1-0.3c0.5-0.7,0.4-1.6-0.3-2.1 C166.7,73.8,165.7,74,165.2,74.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 163.8,
    cy: 79,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 161.2,
    cy: 82.6,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 158.6,
    cy: 86.1,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 156,
    cy: 89.6,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 153.4,
    cy: 93.1,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -16.61 160.2654)",
    style: {
      fill: "#141414"
    },
    cx: 150.8,
    cy: 96.6,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 148.2,
    cy: 100.1,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 145.6,
    cy: 103.7,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M142.3,106.7c-0.3,0.4-0.2,0.9,0.2,1.2c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2 C143.1,106.2,142.6,106.3,142.3,106.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -32.1296 157.5836)",
    style: {
      fill: "#141414"
    },
    cx: 140.4,
    cy: 110.7,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M137.2,113.8c-0.2,0.3-0.2,0.8,0.2,1c0.3,0.2,0.8,0.2,1-0.2c0.2-0.3,0.2-0.8-0.2-1 S137.4,113.4,137.2,113.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M134.6,117.3c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1c0.2-0.3,0.2-0.8-0.1-1 C135.3,116.9,134.8,117,134.6,117.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M132,120.8c-0.2,0.3-0.2,0.7,0.1,1c0.3,0.2,0.7,0.2,1-0.1c0.2-0.3,0.2-0.7-0.1-1 C132.7,120.5,132.2,120.5,132,120.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M129.4,124.4c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 C130.1,124,129.6,124.1,129.4,124.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M126.8,127.9c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 C127.4,127.5,127,127.6,126.8,127.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M124.2,131.4c-0.2,0.3-0.1,0.7,0.1,0.9s0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 S124.4,131.1,124.2,131.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M121.6,134.9c-0.2,0.3-0.1,0.7,0.1,0.9s0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 S121.8,134.6,121.6,134.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M119,138.4c-0.2,0.3-0.1,0.7,0.1,0.9c0.3,0.2,0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 S119.2,138.2,119,138.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M116.4,142c-0.2,0.3-0.2,0.7,0.1,0.9s0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 S116.6,141.7,116.4,142z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M113.8,145.5c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1s0.2-0.7-0.1-0.9 C114.4,145.1,114,145.2,113.8,145.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M111.2,149c-0.2,0.3-0.2,0.7,0.1,1c0.3,0.2,0.7,0.2,1-0.1c0.2-0.3,0.2-0.7-0.1-1 C111.8,148.6,111.4,148.7,111.2,149z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 55.8387 168.7892)",
    style: {
      fill: "#141414"
    },
    cx: 195.5,
    cy: 29,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 51.9588 168.1187)",
    style: {
      fill: "#141414"
    },
    cx: 192.9,
    cy: 32.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 48.0789 167.4482)",
    style: {
      fill: "#141414"
    },
    cx: 190.3,
    cy: 36,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 44.199 166.7778)",
    style: {
      fill: "#141414"
    },
    cx: 187.7,
    cy: 39.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 40.3191 166.1073)",
    style: {
      fill: "#141414"
    },
    cx: 185.1,
    cy: 43,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 36.4392 165.4368)",
    style: {
      fill: "#141414"
    },
    cx: 182.5,
    cy: 46.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 32.5593 164.7664)",
    style: {
      fill: "#141414"
    },
    cx: 179.9,
    cy: 50.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 28.6794 164.0959)",
    style: {
      fill: "#141414"
    },
    cx: 177.2,
    cy: 53.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 24.7995 163.4254)",
    style: {
      fill: "#141414"
    },
    cx: 174.6,
    cy: 57.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M170.5,59.5c-0.6,0.9-0.5,2.1,0.4,2.7s2.1,0.5,2.7-0.4c0.6-0.9,0.5-2.1-0.4-2.7 C172.3,58.4,171.1,58.6,170.5,59.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M168,63c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4s0.4-1.9-0.4-2.5 C169.7,62.1,168.6,62.2,168,63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M165.5,66.6c-0.6,0.8-0.4,1.8,0.4,2.4c0.8,0.6,1.8,0.4,2.4-0.4s0.4-1.8-0.4-2.4 C167.1,65.7,166,65.9,165.5,66.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M162.9,70.2c-0.5,0.7-0.4,1.7,0.3,2.2c0.7,0.5,1.7,0.4,2.2-0.3c0.5-0.7,0.4-1.7-0.3-2.2 C164.5,69.3,163.5,69.5,162.9,70.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M160.4,73.8c-0.5,0.7-0.4,1.6,0.3,2.1c0.7,0.5,1.6,0.4,2.1-0.3c0.5-0.7,0.4-1.6-0.3-2.1 C161.8,73,160.9,73.1,160.4,73.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 159,
    cy: 78.2,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 156.4,
    cy: 81.7,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 153.8,
    cy: 85.2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 151.2,
    cy: 88.7,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 148.6,
    cy: 92.3,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -17.8795 156.0503)",
    style: {
      fill: "#141414"
    },
    cx: 146,
    cy: 95.8,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 143.4,
    cy: 99.3,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 140.8,
    cy: 102.8,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M137.5,105.8c-0.3,0.4-0.2,0.9,0.2,1.2c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2 C138.3,105.4,137.8,105.5,137.5,105.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -33.3991 153.3684)",
    style: {
      fill: "#141414"
    },
    cx: 135.6,
    cy: 109.8,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M132.4,112.9c-0.2,0.3-0.2,0.8,0.2,1c0.3,0.2,0.8,0.2,1-0.2c0.2-0.3,0.2-0.8-0.2-1 C133.1,112.5,132.6,112.6,132.4,112.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M129.8,116.5c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1c0.2-0.3,0.2-0.8-0.1-1 C130.5,116.1,130,116.1,129.8,116.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M127.2,120c-0.2,0.3-0.2,0.7,0.1,1c0.3,0.2,0.7,0.2,1-0.1c0.2-0.3,0.2-0.7-0.1-1 C127.8,119.6,127.4,119.7,127.2,120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M124.6,123.5c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 C125.2,123.2,124.8,123.2,124.6,123.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M122,127c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1s0.2-0.7-0.1-0.9 C122.6,126.7,122.2,126.8,122,127z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M119.4,130.6c-0.2,0.3-0.1,0.7,0.1,0.9s0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 C120,130.2,119.6,130.3,119.4,130.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M116.8,134.1c-0.2,0.3-0.1,0.7,0.1,0.9c0.3,0.2,0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 S117,133.8,116.8,134.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M114.2,137.6c-0.2,0.3-0.1,0.7,0.1,0.9s0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 S114.4,137.3,114.2,137.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M111.6,141.1c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 S111.8,140.8,111.6,141.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M109,144.6c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1s0.2-0.7-0.1-0.9 C109.6,144.3,109.2,144.3,109,144.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M106.4,148.1c-0.2,0.3-0.2,0.7,0.1,1c0.3,0.2,0.7,0.2,1-0.1c0.2-0.3,0.2-0.7-0.1-1 C107,147.8,106.6,147.8,106.4,148.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 54.5692 164.574)",
    style: {
      fill: "#141414"
    },
    cx: 190.7,
    cy: 28.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 50.6893 163.9036)",
    style: {
      fill: "#141414"
    },
    cx: 188.1,
    cy: 31.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 46.8094 163.2331)",
    style: {
      fill: "#141414"
    },
    cx: 185.5,
    cy: 35.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 42.9295 162.5626)",
    style: {
      fill: "#141414"
    },
    cx: 182.9,
    cy: 38.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 39.0496 161.8922)",
    style: {
      fill: "#141414"
    },
    cx: 180.2,
    cy: 42.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 35.1697 161.2217)",
    style: {
      fill: "#141414"
    },
    cx: 177.6,
    cy: 45.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 175,
    cy: 49.2,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 172.4,
    cy: 52.7,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 23.53 159.2103)",
    style: {
      fill: "#141414"
    },
    cx: 169.8,
    cy: 56.2,
    rx: 1.8,
    ry: 1.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M165.8,58.7c-0.6,0.8-0.4,1.8,0.4,2.4s1.8,0.4,2.4-0.4c0.6-0.8,0.4-1.8-0.4-2.4 S166.4,58,165.8,58.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M163.3,62.3c-0.5,0.7-0.4,1.7,0.3,2.3c0.7,0.5,1.7,0.4,2.3-0.3c0.5-0.7,0.4-1.7-0.3-2.3 S163.8,61.6,163.3,62.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 162,
    cy: 66.8,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 159.4,
    cy: 70.3,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 4.1305 155.858)",
    style: {
      fill: "#141414"
    },
    cx: 156.8,
    cy: 73.8,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 0.2506 155.1875)",
    style: {
      fill: "#141414"
    },
    cx: 154.2,
    cy: 77.3,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 151.6,
    cy: 80.9,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 149,
    cy: 84.4,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -11.3891 153.1761)",
    style: {
      fill: "#141414"
    },
    cx: 146.4,
    cy: 87.9,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 143.8,
    cy: 91.4,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -19.149 151.8352)",
    style: {
      fill: "#141414"
    },
    cx: 141.2,
    cy: 94.9,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -23.0289 151.1647)",
    style: {
      fill: "#141414"
    },
    cx: 138.6,
    cy: 98.4,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -26.9088 150.4942)",
    style: {
      fill: "#141414"
    },
    cx: 136,
    cy: 102,
    rx: 0.7,
    ry: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M132.8,105.1c-0.2,0.3-0.2,0.7,0.1,1c0.3,0.2,0.7,0.2,1-0.1c0.2-0.3,0.2-0.7-0.1-1 C133.4,104.7,133,104.8,132.8,105.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M130.2,108.6c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 S130.4,108.3,130.2,108.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M127.6,112.1c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C128.2,111.8,127.8,111.9,127.6,112.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M125.1,115.7c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C125.6,115.4,125.3,115.4,125.1,115.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M122.5,119.2c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 C123,118.9,122.7,119,122.5,119.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M119.9,122.7c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 C120.4,122.4,120.1,122.5,119.9,122.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -54.0681 145.8009)",
    style: {
      fill: "#141414"
    },
    cx: 117.7,
    cy: 126.6,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -57.948 145.1305)",
    style: {
      fill: "#141414"
    },
    cx: 115.1,
    cy: 130.1,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -61.8279 144.46)",
    style: {
      fill: "#141414"
    },
    cx: 112.5,
    cy: 133.6,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M109.5,136.8c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 C110,136.5,109.6,136.6,109.5,136.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M106.8,140.3c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 C107.4,140,107,140.1,106.8,140.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M104.2,143.8c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C104.8,143.5,104.4,143.6,104.2,143.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 57.1796 161.0294)",
    style: {
      fill: "#141414"
    },
    cx: 188.5,
    cy: 23.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 53.2997 160.3589)",
    style: {
      fill: "#141414"
    },
    cx: 185.8,
    cy: 27.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 49.4198 159.6884)",
    style: {
      fill: "#141414"
    },
    cx: 183.2,
    cy: 30.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 45.5399 159.018)",
    style: {
      fill: "#141414"
    },
    cx: 180.6,
    cy: 34.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 41.66 158.3475)",
    style: {
      fill: "#141414"
    },
    cx: 178,
    cy: 37.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 37.7801 157.677)",
    style: {
      fill: "#141414"
    },
    cx: 175.4,
    cy: 41.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 33.9002 157.0066)",
    style: {
      fill: "#141414"
    },
    cx: 172.8,
    cy: 44.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 30.0203 156.3361)",
    style: {
      fill: "#141414"
    },
    cx: 170.2,
    cy: 48.4,
    rx: 2,
    ry: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M166.1,50.8c-0.6,0.8-0.4,2,0.4,2.6c0.8,0.6,2,0.4,2.6-0.4c0.6-0.8,0.4-2-0.4-2.6 C167.9,49.8,166.7,49.9,166.1,50.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M163.6,54.4c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 S164.2,53.6,163.6,54.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M161.1,57.9c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3c0.5-0.7,0.4-1.8-0.3-2.3 C162.6,57.1,161.6,57.2,161.1,57.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M158.6,61.5c-0.5,0.7-0.4,1.6,0.3,2.1c0.7,0.5,1.6,0.4,2.1-0.3c0.5-0.7,0.4-1.6-0.3-2.1 C160,60.7,159.1,60.9,158.6,61.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 10.6208 152.9837)",
    style: {
      fill: "#141414"
    },
    cx: 157.2,
    cy: 65.9,
    rx: 1.4,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 154.6,
    cy: 69.5,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 2.861 151.6428)",
    style: {
      fill: "#141414"
    },
    cx: 152,
    cy: 73,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 149.4,
    cy: 76.5,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 146.8,
    cy: 80,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -8.7787 149.6314)",
    style: {
      fill: "#141414"
    },
    cx: 144.2,
    cy: 83.5,
    rx: 0.9,
    ry: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 141.6,
    cy: 87,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M138.3,90.1c-0.3,0.4-0.2,0.9,0.2,1.1c0.4,0.3,0.9,0.2,1.1-0.2c0.3-0.4,0.2-0.9-0.2-1.1 C139.1,89.7,138.6,89.7,138.3,90.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M135.7,93.6c-0.2,0.3-0.2,0.8,0.2,1s0.8,0.2,1-0.2c0.2-0.3,0.2-0.8-0.2-1 C136.5,93.2,136,93.3,135.7,93.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M133.2,97.2c-0.2,0.3-0.2,0.7,0.1,1c0.3,0.2,0.7,0.2,1-0.1c0.2-0.3,0.2-0.7-0.1-1 C133.8,96.8,133.4,96.9,133.2,97.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M130.6,100.7c-0.2,0.3-0.1,0.7,0.1,0.9s0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 S130.8,100.5,130.6,100.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M128.1,104.3c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1s0.1-0.6-0.1-0.8 C128.6,104,128.2,104,128.1,104.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M125.5,107.8c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 C126,107.5,125.7,107.6,125.5,107.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M122.9,111.4c-0.2,0.2-0.1,0.6,0.1,0.7c0.2,0.2,0.6,0.1,0.7-0.1c0.2-0.2,0.1-0.6-0.1-0.7 C123.4,111.1,123.1,111.1,122.9,111.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M120.3,114.9c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1s0.1-0.5-0.1-0.7 C120.8,114.6,120.5,114.7,120.3,114.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 118.1,
    cy: 118.7,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M115.1,121.9c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1s0.1-0.5-0.1-0.6 C115.6,121.7,115.3,121.7,115.1,121.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M112.5,125.5c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1s0.1-0.5-0.1-0.6 C113,125.2,112.7,125.3,112.5,125.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M109.9,129c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 C110.4,128.8,110.1,128.8,109.9,129z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M107.3,132.5c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 C107.7,132.3,107.5,132.3,107.3,132.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M104.7,136c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1s0.1-0.5-0.1-0.6 C105.1,135.8,104.9,135.8,104.7,136z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M102.1,139.5c-0.2,0.2-0.1,0.5,0.1,0.6c0.2,0.2,0.5,0.1,0.6-0.1c0.2-0.2,0.1-0.5-0.1-0.6 C102.5,139.3,102.3,139.3,102.1,139.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M99.5,143c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C99.9,142.8,99.6,142.8,99.5,143z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 55.9101 156.8142)",
    style: {
      fill: "#141414"
    },
    cx: 183.6,
    cy: 22.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 52.0302 156.1438)",
    style: {
      fill: "#141414"
    },
    cx: 181,
    cy: 26.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 48.1503 155.4733)",
    style: {
      fill: "#141414"
    },
    cx: 178.4,
    cy: 29.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 44.2704 154.8028)",
    style: {
      fill: "#141414"
    },
    cx: 175.8,
    cy: 33.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 40.3905 154.1324)",
    style: {
      fill: "#141414"
    },
    cx: 173.2,
    cy: 37,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 36.5106 153.4619)",
    style: {
      fill: "#141414"
    },
    cx: 170.6,
    cy: 40.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 32.6307 152.7914)",
    style: {
      fill: "#141414"
    },
    cx: 168,
    cy: 44,
    rx: 1.9,
    ry: 1.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M164,46.4c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 C165.7,45.5,164.5,45.7,164,46.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M161.5,50c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3c0.5-0.7,0.4-1.8-0.3-2.3 C163,49.2,162,49.3,161.5,50z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M158.9,53.6c-0.5,0.7-0.4,1.6,0.3,2.2c0.7,0.5,1.6,0.4,2.2-0.3c0.5-0.7,0.4-1.6-0.3-2.2 C160.4,52.8,159.5,52.9,158.9,53.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M156.4,57.2c-0.5,0.6-0.3,1.5,0.3,2c0.6,0.5,1.5,0.3,2-0.3c0.5-0.6,0.3-1.5-0.3-2 C157.8,56.4,156.9,56.6,156.4,57.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 13.2312 149.4391)",
    style: {
      fill: "#141414"
    },
    cx: 155,
    cy: 61.6,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 9.3513 148.7686)",
    style: {
      fill: "#141414"
    },
    cx: 152.4,
    cy: 65.1,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 149.8,
    cy: 68.6,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 147.2,
    cy: 72.1,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 144.6,
    cy: 75.7,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M141.3,78.7c-0.3,0.4-0.2,0.9,0.2,1.2c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2 C142.1,78.2,141.5,78.3,141.3,78.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -10.0482 145.4163)",
    style: {
      fill: "#141414"
    },
    cx: 139.3,
    cy: 82.7,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M136.2,85.8c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1c0.2-0.3,0.2-0.8-0.1-1 C136.8,85.4,136.4,85.5,136.2,85.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M133.6,89.3c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1s0.2-0.7-0.1-0.9 C134.2,89,133.8,89,133.6,89.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M131,92.9c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C131.6,92.6,131.2,92.6,131,92.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M128.5,96.4c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 C129,96.1,128.7,96.2,128.5,96.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M125.9,100c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C126.4,99.7,126.1,99.7,125.9,100z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M123.3,103.5c-0.2,0.2-0.1,0.5,0.1,0.6c0.2,0.2,0.5,0.1,0.6-0.1c0.2-0.2,0.1-0.5-0.1-0.6 C123.8,103.3,123.5,103.3,123.3,103.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -37.2075 140.723)",
    style: {
      fill: "#141414"
    },
    cx: 121.1,
    cy: 107.3,
    rx: 0.4,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M118.2,110.6c-0.1,0.2-0.1,0.4,0.1,0.6s0.4,0.1,0.6-0.1c0.1-0.2,0.1-0.4-0.1-0.6 C118.6,110.4,118.3,110.4,118.2,110.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M115.6,114.1c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5 C115.9,113.9,115.7,113.9,115.6,114.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 113.3,
    cy: 117.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 110.7,
    cy: 121.4,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 108.1,
    cy: 124.9,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 105.5,
    cy: 128.4,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 102.9,
    cy: 131.9,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M100,135.2c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5 C100.3,135,100.1,135,100,135.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M97.3,138.7c-0.1,0.2-0.1,0.4,0.1,0.6c0.2,0.1,0.4,0.1,0.6-0.1c0.1-0.2,0.1-0.4-0.1-0.6 C97.7,138.5,97.5,138.5,97.3,138.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 58.5206 153.2696)",
    style: {
      fill: "#141414"
    },
    cx: 181.4,
    cy: 18.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 54.6407 152.5991)",
    style: {
      fill: "#141414"
    },
    cx: 178.8,
    cy: 22.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 50.7608 151.9286)",
    style: {
      fill: "#141414"
    },
    cx: 176.2,
    cy: 25.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 46.8809 151.2581)",
    style: {
      fill: "#141414"
    },
    cx: 173.6,
    cy: 29.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 43.001 150.5877)",
    style: {
      fill: "#141414"
    },
    cx: 171,
    cy: 32.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 39.1211 149.9172)",
    style: {
      fill: "#141414"
    },
    cx: 168.4,
    cy: 36.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 35.2411 149.2467)",
    style: {
      fill: "#141414"
    },
    cx: 165.8,
    cy: 39.6,
    rx: 2,
    ry: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 31.3612 148.5763)",
    style: {
      fill: "#141414"
    },
    cx: 163.2,
    cy: 43.2,
    rx: 1.8,
    ry: 1.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M159.2,45.7c-0.6,0.8-0.4,1.8,0.4,2.4c0.8,0.6,1.8,0.4,2.4-0.4c0.6-0.8,0.4-1.8-0.4-2.4 C160.8,44.7,159.8,44.9,159.2,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 158,
    cy: 50.2,
    r: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 19.7215 146.5649)",
    style: {
      fill: "#141414"
    },
    cx: 155.4,
    cy: 53.7,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 152.8,
    cy: 57.2,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 150.2,
    cy: 60.7,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 147.5,
    cy: 64.3,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 144.9,
    cy: 67.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 0.322 143.2125)",
    style: {
      fill: "#141414"
    },
    cx: 142.3,
    cy: 71.3,
    rx: 0.9,
    ry: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M139,74.3c-0.3,0.4-0.2,0.9,0.2,1.2c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2 C139.9,73.8,139.3,73.9,139,74.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -7.4378 141.8716)",
    style: {
      fill: "#141414"
    },
    cx: 137.1,
    cy: 78.3,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M134,81.4c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1c0.2-0.3,0.2-0.8-0.1-1 C134.6,81,134.2,81.1,134,81.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M131.4,85c-0.2,0.3-0.1,0.7,0.1,0.9s0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9S131.6,84.7,131.4,85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M128.9,88.5c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1s0.1-0.6-0.1-0.8 C129.4,88.2,129,88.3,128.9,88.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M126.3,92.1c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1s0.1-0.5-0.1-0.7 S126.5,91.9,126.3,92.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M123.7,95.6c-0.2,0.2-0.1,0.5,0.1,0.6c0.2,0.2,0.5,0.1,0.6-0.1c0.2-0.2,0.1-0.5-0.1-0.6 C124.2,95.4,123.9,95.4,123.7,95.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -30.7172 137.8488)",
    style: {
      fill: "#141414"
    },
    cx: 121.5,
    cy: 99.4,
    rx: 0.4,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M118.6,102.7c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5 C118.9,102.5,118.7,102.5,118.6,102.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 116.3,
    cy: 106.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 113.7,
    cy: 110,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 111.1,
    cy: 113.5,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 108.5,
    cy: 117,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 105.9,
    cy: 120.5,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 103.3,
    cy: 124,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 100.6,
    cy: 127.6,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 98,
    cy: 131.1,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 95.4,
    cy: 134.6,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -73.3962 130.4737)",
    style: {
      fill: "#141414"
    },
    cx: 92.8,
    cy: 138.1,
    rx: 0.3,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 57.2511 149.0544)",
    style: {
      fill: "#141414"
    },
    cx: 176.6,
    cy: 17.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 53.3712 148.384)",
    style: {
      fill: "#141414"
    },
    cx: 174,
    cy: 21.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 49.4913 147.7135)",
    style: {
      fill: "#141414"
    },
    cx: 171.4,
    cy: 24.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 45.6114 147.043)",
    style: {
      fill: "#141414"
    },
    cx: 168.8,
    cy: 28.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 166.2,
    cy: 31.8,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 37.8516 145.7021)",
    style: {
      fill: "#141414"
    },
    cx: 163.6,
    cy: 35.3,
    rx: 1.9,
    ry: 1.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M159.5,37.7c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4s0.4-1.9-0.4-2.5 S160.1,36.9,159.5,37.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M157,41.3c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3c0.5-0.7,0.4-1.8-0.3-2.3 C158.6,40.5,157.6,40.6,157,41.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 155.8,
    cy: 45.8,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 22.332 143.0202)",
    style: {
      fill: "#141414"
    },
    cx: 153.2,
    cy: 49.3,
    rx: 1.4,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 18.452 142.3497)",
    style: {
      fill: "#141414"
    },
    cx: 150.5,
    cy: 52.9,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 14.5721 141.6793)",
    style: {
      fill: "#141414"
    },
    cx: 147.9,
    cy: 56.4,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 10.6922 141.0088)",
    style: {
      fill: "#141414"
    },
    cx: 145.3,
    cy: 59.9,
    rx: 1.1,
    ry: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 142.7,
    cy: 63.4,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 140.1,
    cy: 66.9,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -0.9475 138.9974)",
    style: {
      fill: "#141414"
    },
    cx: 137.5,
    cy: 70.4,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M134.3,73.5c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1c0.2-0.3,0.2-0.8-0.1-1 C135,73.2,134.6,73.2,134.3,73.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M131.8,77.1c-0.2,0.3-0.1,0.7,0.1,0.9c0.3,0.2,0.7,0.1,0.9-0.1c0.2-0.3,0.1-0.7-0.1-0.9 C132.4,76.8,132,76.8,131.8,77.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M129.3,80.7c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 C129.8,80.4,129.4,80.4,129.3,80.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M126.7,84.2c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 S126.9,84,126.7,84.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M124.1,87.8c-0.1,0.2-0.1,0.5,0.1,0.6s0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 S124.3,87.6,124.1,87.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 121.9,
    cy: 91.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M119,94.9c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1s0.1-0.4-0.1-0.5 C119.3,94.7,119.1,94.7,119,94.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 116.7,
    cy: 98.6,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 114.1,
    cy: 102.1,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 111.5,
    cy: 105.6,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -43.6264 131.6223)",
    style: {
      fill: "#141414"
    },
    cx: 108.9,
    cy: 109.1,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 106.3,
    cy: 112.6,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -51.3862 130.2813)",
    style: {
      fill: "#141414"
    },
    cx: 103.6,
    cy: 116.2,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -55.2661 129.6109)",
    style: {
      fill: "#141414"
    },
    cx: 101,
    cy: 119.7,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -59.146 128.9404)",
    style: {
      fill: "#141414"
    },
    cx: 98.4,
    cy: 123.2,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 95.8,
    cy: 126.7,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -66.9058 127.5995)",
    style: {
      fill: "#141414"
    },
    cx: 93.2,
    cy: 130.2,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 90.6,
    cy: 133.7,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 59.8615 145.5098)",
    style: {
      fill: "#141414"
    },
    cx: 174.4,
    cy: 13.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 55.9816 144.8393)",
    style: {
      fill: "#141414"
    },
    cx: 171.8,
    cy: 16.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 52.1017 144.1688)",
    style: {
      fill: "#141414"
    },
    cx: 169.2,
    cy: 20.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 48.2218 143.4984)",
    style: {
      fill: "#141414"
    },
    cx: 166.6,
    cy: 23.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 44.3419 142.8279)",
    style: {
      fill: "#141414"
    },
    cx: 164,
    cy: 27.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 40.462 142.1574)",
    style: {
      fill: "#141414"
    },
    cx: 161.4,
    cy: 30.9,
    rx: 2,
    ry: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M157.3,33.3c-0.6,0.8-0.4,2,0.4,2.6c0.8,0.6,2,0.4,2.6-0.4c0.6-0.8,0.4-2-0.4-2.6 C159,32.4,157.9,32.5,157.3,33.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M154.8,36.9c-0.6,0.8-0.4,1.8,0.4,2.4c0.8,0.6,1.8,0.4,2.4-0.4c0.6-0.8,0.4-1.8-0.4-2.4 C156.4,36,155.3,36.2,154.8,36.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 153.5,
    cy: 41.5,
    r: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 150.9,
    cy: 45,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 148.3,
    cy: 48.5,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 145.7,
    cy: 52,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 143.1,
    cy: 55.5,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 140.5,
    cy: 59,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 5.5429 136.1232)",
    style: {
      fill: "#141414"
    },
    cx: 137.9,
    cy: 62.6,
    rx: 0.9,
    ry: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M134.7,65.6c-0.3,0.4-0.2,0.9,0.2,1.1c0.4,0.3,0.9,0.2,1.1-0.2c0.3-0.4,0.2-0.9-0.2-1.1 S134.9,65.2,134.7,65.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M132.1,69.2c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1s0.2-0.8-0.1-1 C132.8,68.8,132.4,68.9,132.1,69.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M129.6,72.7c-0.2,0.3-0.1,0.7,0.1,0.9s0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9S129.8,72.5,129.6,72.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M127,76.3c-0.2,0.2-0.1,0.6,0.1,0.8s0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8S127.2,76,127,76.3 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M124.5,79.9c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C125,79.6,124.7,79.6,124.5,79.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -17.7366 132.1004)",
    style: {
      fill: "#141414"
    },
    cx: 122.3,
    cy: 83.7,
    rx: 0.4,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 119.7,
    cy: 87.2,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -25.4964 130.7595)",
    style: {
      fill: "#141414"
    },
    cx: 117.1,
    cy: 90.7,
    rx: 0.3,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 114.5,
    cy: 94.2,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 111.9,
    cy: 97.7,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -37.1361 128.7481)",
    style: {
      fill: "#141414"
    },
    cx: 109.2,
    cy: 101.2,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 106.6,
    cy: 104.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 104,
    cy: 108.3,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 101.4,
    cy: 111.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 98.8,
    cy: 115.3,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 96.2,
    cy: 118.8,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 93.6,
    cy: 122.3,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 91,
    cy: 125.9,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 88.4,
    cy: 129.4,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 85.8,
    cy: 132.9,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 58.592 141.2946)",
    style: {
      fill: "#141414"
    },
    cx: 169.6,
    cy: 12.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 54.7121 140.6241)",
    style: {
      fill: "#141414"
    },
    cx: 167,
    cy: 16,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 50.8322 139.9537)",
    style: {
      fill: "#141414"
    },
    cx: 164.4,
    cy: 19.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 46.9523 139.2832)",
    style: {
      fill: "#141414"
    },
    cx: 161.8,
    cy: 23,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M157.6,25.4c-0.6,0.9-0.5,2.1,0.4,2.7c0.9,0.6,2.1,0.5,2.7-0.4c0.6-0.9,0.5-2.1-0.4-2.7 C159.4,24.4,158.2,24.6,157.6,25.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M155.1,29c-0.6,0.8-0.4,1.9,0.4,2.5s1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 S155.7,28.2,155.1,29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M152.6,32.6c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3c0.5-0.7,0.4-1.8-0.3-2.3 C154.2,31.7,153.2,31.9,152.6,32.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 151.3,
    cy: 37.1,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 148.7,
    cy: 40.6,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 146.1,
    cy: 44.1,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 143.5,
    cy: 47.6,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 140.9,
    cy: 51.2,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 138.3,
    cy: 54.7,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M135,57.7c-0.3,0.4-0.2,0.9,0.2,1.2c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2 C135.8,57.3,135.3,57.3,135,57.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 4.2734 131.9081)",
    style: {
      fill: "#141414"
    },
    cx: 133.1,
    cy: 61.7,
    rx: 0.7,
    ry: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M130,64.8c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1s0.2-0.7-0.1-0.9 S130.2,64.6,130,64.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M127.4,68.4c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 C128,68.1,127.6,68.2,127.4,68.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M124.9,72c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C125.3,71.7,125,71.7,124.9,72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -11.2462 129.2262)",
    style: {
      fill: "#141414"
    },
    cx: 122.7,
    cy: 75.8,
    rx: 0.4,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 120.1,
    cy: 79.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 117.5,
    cy: 82.8,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 114.9,
    cy: 86.3,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 112.2,
    cy: 89.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 109.6,
    cy: 93.4,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 107,
    cy: 96.9,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 104.4,
    cy: 100.4,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 101.8,
    cy: 103.9,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -46.1654 123.192)",
    style: {
      fill: "#141414"
    },
    cx: 99.2,
    cy: 107.4,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -50.0453 122.5215)",
    style: {
      fill: "#141414"
    },
    cx: 96.6,
    cy: 110.9,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 94,
    cy: 114.5,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 91.4,
    cy: 118,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -61.685 120.5101)",
    style: {
      fill: "#141414"
    },
    cx: 88.8,
    cy: 121.5,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 86.2,
    cy: 125,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -69.4448 119.1692)",
    style: {
      fill: "#141414"
    },
    cx: 83.6,
    cy: 128.5,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 61.2024 137.7499)",
    style: {
      fill: "#141414"
    },
    cx: 167.4,
    cy: 8.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 57.3225 137.0795)",
    style: {
      fill: "#141414"
    },
    cx: 164.7,
    cy: 11.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 53.4426 136.409)",
    style: {
      fill: "#141414"
    },
    cx: 162.1,
    cy: 15.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 49.5627 135.7385)",
    style: {
      fill: "#141414"
    },
    cx: 159.5,
    cy: 18.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M155.3,21c-0.7,0.9-0.5,2.1,0.4,2.8c0.9,0.7,2.1,0.5,2.8-0.4c0.7-0.9,0.5-2.1-0.4-2.8 C157.2,19.9,156,20.1,155.3,21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M152.8,24.6c-0.6,0.8-0.4,2,0.4,2.6c0.8,0.6,2,0.4,2.6-0.4c0.6-0.8,0.4-2-0.4-2.6 S153.4,23.8,152.8,24.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M150.3,28.2c-0.6,0.8-0.4,1.8,0.4,2.4c0.8,0.6,1.8,0.4,2.4-0.4c0.6-0.8,0.4-1.8-0.4-2.4 C152,27.3,150.9,27.4,150.3,28.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M147.8,31.8c-0.5,0.7-0.4,1.7,0.3,2.2c0.7,0.5,1.7,0.4,2.2-0.3c0.5-0.7,0.4-1.7-0.3-2.2 C149.4,30.9,148.4,31.1,147.8,31.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 146.5,
    cy: 36.2,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 143.9,
    cy: 39.8,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 141.3,
    cy: 43.3,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 18.5235 130.3748)",
    style: {
      fill: "#141414"
    },
    cx: 138.7,
    cy: 46.8,
    rx: 1.1,
    ry: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 14.6436 129.7043)",
    style: {
      fill: "#141414"
    },
    cx: 136.1,
    cy: 50.3,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M132.8,53.3c-0.3,0.4-0.2,0.9,0.2,1.2c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2 C133.6,52.9,133.1,52.9,132.8,53.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M130.3,56.9c-0.3,0.3-0.2,0.8,0.2,1.1c0.3,0.3,0.8,0.2,1.1-0.2c0.3-0.3,0.2-0.8-0.2-1.1 C131,56.5,130.5,56.6,130.3,56.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M127.7,60.5c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1s0.2-0.7-0.1-0.9 C128.4,60.1,128,60.2,127.7,60.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M125.2,64c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1s0.1-0.6-0.1-0.8 C125.8,63.7,125.4,63.8,125.2,64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M122.6,67.6c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C123.1,67.3,122.8,67.4,122.6,67.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M120.1,71.2c-0.1,0.2-0.1,0.5,0.1,0.6s0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 S120.2,71,120.1,71.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 117.8,
    cy: 74.9,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 115.2,
    cy: 78.4,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 112.6,
    cy: 82,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -24.1554 122.9997)",
    style: {
      fill: "#141414"
    },
    cx: 110,
    cy: 85.5,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 107.4,
    cy: 89,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 104.8,
    cy: 92.5,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 102.2,
    cy: 96,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 99.6,
    cy: 99.5,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 97,
    cy: 103.1,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 94.4,
    cy: 106.6,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 91.8,
    cy: 110.1,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 89.2,
    cy: 113.6,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 86.6,
    cy: 117.1,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 84,
    cy: 120.6,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 81.4,
    cy: 124.2,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 78.8,
    cy: 127.7,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 59.933 133.5348)",
    style: {
      fill: "#141414"
    },
    cx: 162.5,
    cy: 7.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 56.0531 132.8643)",
    style: {
      fill: "#141414"
    },
    cx: 159.9,
    cy: 10.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 157.3,
    cy: 14.3,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 48.2932 131.5234)",
    style: {
      fill: "#141414"
    },
    cx: 154.7,
    cy: 17.8,
    rx: 2,
    ry: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M150.7,20.3c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4s0.4-1.9-0.4-2.5 S151.3,19.5,150.7,20.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M148.2,23.9c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3s0.4-1.8-0.3-2.3 C149.8,23,148.7,23.1,148.2,23.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 146.9,
    cy: 28.4,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 144.3,
    cy: 31.9,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 141.7,
    cy: 35.4,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 139.1,
    cy: 38.9,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 136.5,
    cy: 42.4,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 133.9,
    cy: 46,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 131.3,
    cy: 49.5,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M128.1,52.6c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1s0.2-0.8-0.1-1 C128.8,52.2,128.3,52.2,128.1,52.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M125.6,56.1c-0.2,0.3-0.1,0.7,0.1,0.9c0.3,0.2,0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 C126.2,55.8,125.8,55.9,125.6,56.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 1.7344 123.4778)",
    style: {
      fill: "#141414"
    },
    cx: 123.5,
    cy: 60,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M120.5,63.3c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1s0.1-0.5-0.1-0.6 C120.9,63,120.6,63.1,120.5,63.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M117.9,66.8c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5 C118.3,66.6,118.1,66.7,117.9,66.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -9.9053 121.4664)",
    style: {
      fill: "#141414"
    },
    cx: 115.6,
    cy: 70.6,
    rx: 0.3,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 113,
    cy: 74.1,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -17.6651 120.1255)",
    style: {
      fill: "#141414"
    },
    cx: 110.4,
    cy: 77.6,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 107.8,
    cy: 81.1,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -25.4249 118.7845)",
    style: {
      fill: "#141414"
    },
    cx: 105.2,
    cy: 84.6,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 102.6,
    cy: 88.1,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 100,
    cy: 91.7,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 97.4,
    cy: 95.2,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 94.8,
    cy: 98.7,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 92.2,
    cy: 102.2,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -48.7044 114.7617)",
    style: {
      fill: "#141414"
    },
    cx: 89.6,
    cy: 105.7,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -52.5843 114.0912)",
    style: {
      fill: "#141414"
    },
    cx: 87,
    cy: 109.2,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -56.4642 113.4208)",
    style: {
      fill: "#141414"
    },
    cx: 84.4,
    cy: 112.8,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 81.8,
    cy: 116.3,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 79.2,
    cy: 119.8,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 76.6,
    cy: 123.3,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 62.5434 129.9901)",
    style: {
      fill: "#141414"
    },
    cx: 160.3,
    cy: 2.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 58.6635 129.3197)",
    style: {
      fill: "#141414"
    },
    cx: 157.7,
    cy: 6.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 54.7836 128.6492)",
    style: {
      fill: "#141414"
    },
    cx: 155.1,
    cy: 9.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 50.9037 127.9787)",
    style: {
      fill: "#141414"
    },
    cx: 152.5,
    cy: 13.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 47.0238 127.3083)",
    style: {
      fill: "#141414"
    },
    cx: 149.9,
    cy: 17,
    rx: 1.9,
    ry: 1.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M145.9,19.4c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4s0.4-1.9-0.4-2.5 C147.6,18.5,146.5,18.7,145.9,19.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M143.4,23c-0.5,0.7-0.4,1.7,0.3,2.3c0.7,0.5,1.7,0.4,2.3-0.3c0.5-0.7,0.4-1.7-0.3-2.3 C144.9,22.2,143.9,22.3,143.4,23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 142.1,
    cy: 27.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 139.5,
    cy: 31,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 136.9,
    cy: 34.6,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 134.3,
    cy: 38.1,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 131.7,
    cy: 41.6,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 129.1,
    cy: 45.1,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M125.8,48.2c-0.3,0.3-0.2,0.8,0.2,1.1c0.3,0.3,0.8,0.2,1.1-0.2c0.3-0.3,0.2-0.8-0.2-1.1 C126.6,47.8,126.1,47.8,125.8,48.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M123.3,51.7c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 S123.5,51.4,123.3,51.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M120.8,55.3c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1s0.1-0.6-0.1-0.8 C121.3,55,121,55.1,120.8,55.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M118.2,58.9c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C118.7,58.6,118.4,58.7,118.2,58.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 116,
    cy: 62.7,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M113.1,66c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1s0.1-0.4-0.1-0.5 C113.5,65.8,113.3,65.9,113.1,66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 110.8,
    cy: 69.7,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 108.2,
    cy: 73.2,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 105.6,
    cy: 76.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -22.8145 115.2398)",
    style: {
      fill: "#141414"
    },
    cx: 103,
    cy: 80.3,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 100.4,
    cy: 83.8,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 97.8,
    cy: 87.3,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 95.2,
    cy: 90.8,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -38.3341 112.558)",
    style: {
      fill: "#141414"
    },
    cx: 92.6,
    cy: 94.3,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -42.214 111.8875)",
    style: {
      fill: "#141414"
    },
    cx: 90,
    cy: 97.9,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -69.3734 107.1942)",
    style: {
      fill: "#141414"
    },
    cx: 71.7,
    cy: 122.5,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 61.2739 125.775)",
    style: {
      fill: "#141414"
    },
    cx: 155.5,
    cy: 2.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 57.394 125.1045)",
    style: {
      fill: "#141414"
    },
    cx: 152.9,
    cy: 5.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 150.3,
    cy: 9.1,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M146.2,11.5c-0.6,0.8-0.4,2,0.4,2.6c0.8,0.6,2,0.4,2.6-0.4c0.6-0.8,0.4-2-0.4-2.6 C148,10.5,146.8,10.7,146.2,11.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M143.7,15.1c-0.6,0.8-0.4,1.8,0.4,2.4c0.8,0.6,1.8,0.4,2.4-0.4c0.6-0.8,0.4-1.8-0.4-2.4 C145.3,14.2,144.3,14.3,143.7,15.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M141.2,18.7c-0.5,0.7-0.4,1.7,0.3,2.2c0.7,0.5,1.7,0.4,2.2-0.3c0.5-0.7,0.4-1.7-0.3-2.2 S141.7,18,141.2,18.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M138.7,22.3c-0.5,0.6-0.3,1.5,0.3,2s1.5,0.3,2-0.3c0.5-0.6,0.3-1.5-0.3-2S139.2,21.7,138.7,22.3 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 137.3,
    cy: 26.7,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 134.7,
    cy: 30.2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 26.3548 119.7408)",
    style: {
      fill: "#141414"
    },
    cx: 132.1,
    cy: 33.7,
    rx: 1.1,
    ry: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 129.4,
    cy: 37.2,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M126.2,40.2c-0.3,0.4-0.2,0.9,0.2,1.2c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2 C127,39.8,126.4,39.9,126.2,40.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 14.715 117.7294)",
    style: {
      fill: "#141414"
    },
    cx: 124.2,
    cy: 44.3,
    rx: 0.7,
    ry: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M121.1,47.4c-0.2,0.3-0.1,0.7,0.1,0.9c0.3,0.2,0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 C121.7,47.1,121.3,47.1,121.1,47.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 6.9552 116.3885)",
    style: {
      fill: "#141414"
    },
    cx: 119,
    cy: 51.3,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M116.1,54.5c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1s0.1-0.5-0.1-0.6 C116.5,54.3,116.2,54.3,116.1,54.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 113.8,
    cy: 58.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 111.2,
    cy: 61.8,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -8.5644 113.7066)",
    style: {
      fill: "#141414"
    },
    cx: 108.6,
    cy: 65.4,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 106,
    cy: 68.9,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -16.3242 112.3656)",
    style: {
      fill: "#141414"
    },
    cx: 103.4,
    cy: 72.4,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 100.8,
    cy: 75.9,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 98.2,
    cy: 79.4,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 95.6,
    cy: 82.9,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -31.8438 109.6838)",
    style: {
      fill: "#141414"
    },
    cx: 93,
    cy: 86.5,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 63.8843 122.2303)",
    style: {
      fill: "#141414"
    },
    cx: 153.3,
    cy: -2.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 60.0044 121.5599)",
    style: {
      fill: "#141414"
    },
    cx: 150.7,
    cy: 1.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 56.1245 120.8894)",
    style: {
      fill: "#141414"
    },
    cx: 148.1,
    cy: 4.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 145.5,
    cy: 8.2,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M141.4,10.7c-0.6,0.8-0.4,2,0.4,2.6c0.8,0.6,2,0.4,2.6-0.4s0.4-2-0.4-2.6 C143.1,9.7,142,9.9,141.4,10.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M138.9,14.3c-0.6,0.7-0.4,1.8,0.4,2.4c0.7,0.6,1.8,0.4,2.4-0.4c0.6-0.7,0.4-1.8-0.4-2.4 S139.5,13.5,138.9,14.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M136.4,17.9c-0.5,0.7-0.4,1.6,0.3,2.2s1.6,0.4,2.2-0.3c0.5-0.7,0.4-1.6-0.3-2.2 S136.9,17.2,136.4,17.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 36.725 117.5371)",
    style: {
      fill: "#141414"
    },
    cx: 135,
    cy: 22.3,
    rx: 1.4,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 32.8451 116.8666)",
    style: {
      fill: "#141414"
    },
    cx: 132.4,
    cy: 25.8,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 129.8,
    cy: 29.3,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 127.2,
    cy: 32.9,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 124.6,
    cy: 36.4,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 122,
    cy: 39.9,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M118.9,43c-0.2,0.3-0.2,0.7,0.1,1s0.7,0.2,1-0.1c0.2-0.3,0.2-0.7-0.1-1S119.1,42.7,118.9,43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M116.3,46.6c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C116.9,46.3,116.5,46.3,116.3,46.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M113.8,50.1c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1s0.1-0.5-0.1-0.7 S114,49.9,113.8,50.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 111.6,
    cy: 54,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M108.7,57.3c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5 C109,57.1,108.8,57.1,108.7,57.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 106.4,
    cy: 61,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -9.8339 109.4914)",
    style: {
      fill: "#141414"
    },
    cx: 103.8,
    cy: 64.5,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 101.2,
    cy: 68,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -17.5937 108.1505)",
    style: {
      fill: "#141414"
    },
    cx: 98.6,
    cy: 71.5,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 96,
    cy: 75.1,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 93.4,
    cy: 78.6,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -29.2334 106.1391)",
    style: {
      fill: "#141414"
    },
    cx: 90.8,
    cy: 82.1,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 62.6148 118.0152)",
    style: {
      fill: "#141414"
    },
    cx: 148.5,
    cy: -3.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 58.7349 117.3447)",
    style: {
      fill: "#141414"
    },
    cx: 145.9,
    cy: 0.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 143.3,
    cy: 3.9,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M139.2,6.3c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4s0.4-1.9-0.4-2.5 S139.8,5.5,139.2,6.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M136.7,9.9c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3s0.4-1.8-0.3-2.3 S137.3,9.2,136.7,9.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M134.2,13.5c-0.5,0.7-0.4,1.6,0.3,2.1c0.7,0.5,1.6,0.4,2.1-0.3c0.5-0.7,0.4-1.6-0.3-2.1 C135.7,12.7,134.7,12.9,134.2,13.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 132.8,
    cy: 17.9,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 130.2,
    cy: 21.5,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 127.6,
    cy: 25,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 27.6957 111.981)",
    style: {
      fill: "#141414"
    },
    cx: 125,
    cy: 28.5,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 122.4,
    cy: 32,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M119.2,35.1c-0.3,0.3-0.2,0.8,0.2,1.1c0.3,0.3,0.8,0.2,1.1-0.2s0.2-0.8-0.2-1.1 C119.9,34.7,119.4,34.7,119.2,35.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M116.7,38.7c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 C117.3,38.3,116.9,38.4,116.7,38.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M114.1,42.2c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 C114.7,41.9,114.3,42,114.1,42.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 112,
    cy: 46.1,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 109.4,
    cy: 49.6,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 106.8,
    cy: 53.1,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 104.2,
    cy: 56.6,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 101.6,
    cy: 60.1,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -11.1033 105.2763)",
    style: {
      fill: "#141414"
    },
    cx: 99,
    cy: 63.7,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 96.4,
    cy: 67.2,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 93.8,
    cy: 70.7,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -22.7431 103.2649)",
    style: {
      fill: "#141414"
    },
    cx: 91.1,
    cy: 74.2,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 65.2252 114.4705)",
    style: {
      fill: "#141414"
    },
    cx: 146.3,
    cy: -7.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 61.3453 113.8)",
    style: {
      fill: "#141414"
    },
    cx: 143.6,
    cy: -4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 141,
    cy: -0.5,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M136.9,1.9c-0.6,0.9-0.5,2.1,0.4,2.7s2.1,0.5,2.7-0.4c0.6-0.9,0.5-2.1-0.4-2.7 S137.5,1,136.9,1.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M134.4,5.5c-0.6,0.8-0.4,1.9,0.4,2.5s1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 S135,4.7,134.4,5.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M131.9,9.1c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3c0.5-0.7,0.4-1.8-0.3-2.3 C133.5,8.2,132.4,8.4,131.9,9.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M129.4,12.7c-0.5,0.7-0.4,1.6,0.3,2.1c0.7,0.5,1.6,0.4,2.1-0.3c0.5-0.7,0.4-1.6-0.3-2.1 C130.8,11.9,129.9,12,129.4,12.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 128,
    cy: 17.1,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 125.4,
    cy: 20.6,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 122.8,
    cy: 24.1,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 26.4262 107.7658)",
    style: {
      fill: "#141414"
    },
    cx: 120.2,
    cy: 27.6,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 117.6,
    cy: 31.2,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M114.4,34.2c-0.2,0.3-0.2,0.8,0.2,1c0.3,0.2,0.8,0.2,1-0.2c0.2-0.3,0.2-0.8-0.2-1 C115.1,33.8,114.6,33.9,114.4,34.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M111.9,37.8c-0.2,0.3-0.1,0.7,0.1,0.9c0.3,0.2,0.7,0.1,0.9-0.1c0.2-0.3,0.1-0.7-0.1-0.9 S112.1,37.5,111.9,37.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 10.9066 105.084)",
    style: {
      fill: "#141414"
    },
    cx: 109.8,
    cy: 41.7,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M106.8,45c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 C107.2,44.7,107,44.8,106.8,45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 104.6,
    cy: 48.7,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 102,
    cy: 52.3,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 99.4,
    cy: 55.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 96.7,
    cy: 59.3,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -12.3728 101.0612)",
    style: {
      fill: "#141414"
    },
    cx: 94.1,
    cy: 62.8,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 91.5,
    cy: 66.3,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 88.9,
    cy: 69.8,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 63.9558 110.2554)",
    style: {
      fill: "#141414"
    },
    cx: 141.4,
    cy: -8.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 60.0759 109.5849)",
    style: {
      fill: "#141414"
    },
    cx: 138.8,
    cy: -4.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 56.196 108.9144)",
    style: {
      fill: "#141414"
    },
    cx: 136.2,
    cy: -1.3,
    rx: 1.9,
    ry: 1.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M132.2,1.1c-0.6,0.8-0.4,1.9,0.4,2.5s1.9,0.4,2.5-0.4s0.4-1.9-0.4-2.5S132.8,0.3,132.2,1.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M129.7,4.7c-0.5,0.7-0.4,1.7,0.3,2.3c0.7,0.5,1.7,0.4,2.3-0.3c0.5-0.7,0.4-1.7-0.3-2.3 C131.3,3.9,130.2,4,129.7,4.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 44.5562 106.903)",
    style: {
      fill: "#141414"
    },
    cx: 128.4,
    cy: 9.2,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 125.8,
    cy: 12.7,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 123.2,
    cy: 16.3,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 32.9165 104.8916)",
    style: {
      fill: "#141414"
    },
    cx: 120.6,
    cy: 19.8,
    rx: 1.1,
    ry: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 29.0366 104.2212)",
    style: {
      fill: "#141414"
    },
    cx: 118,
    cy: 23.3,
    rx: 0.9,
    ry: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 25.1567 103.5507)",
    style: {
      fill: "#141414"
    },
    cx: 115.4,
    cy: 26.8,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 21.2768 102.8802)",
    style: {
      fill: "#141414"
    },
    cx: 112.8,
    cy: 30.3,
    rx: 0.7,
    ry: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M109.7,33.5c-0.2,0.3-0.1,0.7,0.1,0.9c0.3,0.2,0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 C110.3,33.1,109.9,33.2,109.7,33.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M107.1,37c-0.2,0.2-0.1,0.6,0.1,0.7s0.6,0.1,0.7-0.1c0.2-0.2,0.1-0.6-0.1-0.7 S107.3,36.8,107.1,37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M104.6,40.6c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 C105,40.4,104.7,40.4,104.6,40.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 102.4,
    cy: 44.4,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 99.7,
    cy: 47.9,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -2.0026 98.8574)",
    style: {
      fill: "#141414"
    },
    cx: 97.1,
    cy: 51.4,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 94.5,
    cy: 54.9,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 91.9,
    cy: 58.4,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 89.3,
    cy: 62,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -17.5222 96.1756)",
    style: {
      fill: "#141414"
    },
    cx: 86.7,
    cy: 65.5,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 66.5662 106.7107)",
    style: {
      fill: "#141414"
    },
    cx: 139.2,
    cy: -12.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 62.6863 106.0402)",
    style: {
      fill: "#141414"
    },
    cx: 136.6,
    cy: -9.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 134,
    cy: -5.7,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 54.9265 104.6993)",
    style: {
      fill: "#141414"
    },
    cx: 131.4,
    cy: -2.2,
    rx: 1.9,
    ry: 1.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M127.4,0.3c-0.6,0.8-0.4,1.9,0.4,2.5s1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 C129.1-0.7,128-0.5,127.4,0.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M124.9,3.9c-0.5,0.7-0.4,1.7,0.3,2.2c0.7,0.5,1.7,0.4,2.2-0.3c0.5-0.7,0.4-1.7-0.3-2.2 C126.4,3,125.4,3.2,124.9,3.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 123.6,
    cy: 8.4,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 39.4069 102.0174)",
    style: {
      fill: "#141414"
    },
    cx: 121,
    cy: 11.9,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 35.5269 101.347)",
    style: {
      fill: "#141414"
    },
    cx: 118.4,
    cy: 15.4,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 115.8,
    cy: 18.9,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 113.2,
    cy: 22.4,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M109.9,25.5c-0.3,0.4-0.2,0.9,0.2,1.2c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2 C110.7,25,110.2,25.1,109.9,25.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M107.4,29c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1c0.2-0.3,0.2-0.8-0.1-1 C108.1,28.7,107.6,28.7,107.4,29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M104.9,32.6c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C105.4,32.3,105.1,32.4,104.9,32.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M102.3,36.2c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C102.8,35.9,102.5,36,102.3,36.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 8.3676 96.6537)",
    style: {
      fill: "#141414"
    },
    cx: 100.1,
    cy: 40,
    rx: 0.4,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M97.3,43.3c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1s0.1-0.4-0.1-0.5 C97.6,43.2,97.4,43.2,97.3,43.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 94.9,
    cy: 47.1,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 92.3,
    cy: 50.6,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 89.7,
    cy: 54.1,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 87.1,
    cy: 57.6,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 84.5,
    cy: 61.1,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 65.2967 102.4956)",
    style: {
      fill: "#141414"
    },
    cx: 134.4,
    cy: -13.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 61.4168 101.8251)",
    style: {
      fill: "#141414"
    },
    cx: 131.8,
    cy: -10.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 57.5369 101.1546)",
    style: {
      fill: "#141414"
    },
    cx: 129.2,
    cy: -6.5,
    rx: 1.9,
    ry: 1.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M125.2-4.1c-0.6,0.8-0.4,1.9,0.4,2.4c0.8,0.6,1.9,0.4,2.4-0.4c0.6-0.8,0.4-1.9-0.4-2.4 C126.8-5,125.8-4.8,125.2-4.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M122.7-0.5c-0.5,0.7-0.4,1.7,0.3,2.2c0.7,0.5,1.7,0.4,2.2-0.3s0.4-1.7-0.3-2.2 C124.2-1.3,123.2-1.2,122.7-0.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 121.4,
    cy: 4,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 42.0173 98.4728)",
    style: {
      fill: "#141414"
    },
    cx: 118.8,
    cy: 7.5,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 38.1374 97.8023)",
    style: {
      fill: "#141414"
    },
    cx: 116.2,
    cy: 11,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 34.2575 97.1318)",
    style: {
      fill: "#141414"
    },
    cx: 113.6,
    cy: 14.6,
    rx: 1.1,
    ry: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 111,
    cy: 18.1,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 108.3,
    cy: 21.6,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M105.2,24.7c-0.2,0.3-0.2,0.8,0.1,1s0.8,0.2,1-0.1c0.2-0.3,0.2-0.8-0.1-1 C105.8,24.3,105.4,24.4,105.2,24.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M102.6,28.3c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C103.2,27.9,102.8,28,102.6,28.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M100.1,31.8c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 S100.3,31.6,100.1,31.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 97.9,
    cy: 35.7,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 95.3,
    cy: 39.2,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 92.7,
    cy: 42.7,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 90.1,
    cy: 46.2,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -4.5416 90.4272)",
    style: {
      fill: "#141414"
    },
    cx: 87.5,
    cy: 49.7,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 84.9,
    cy: 53.2,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 82.3,
    cy: 56.8,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -16.1813 88.4158)",
    style: {
      fill: "#141414"
    },
    cx: 79.7,
    cy: 60.3,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 67.9071 98.9509)",
    style: {
      fill: "#141414"
    },
    cx: 132.2,
    cy: -17.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 64.0272 98.2804)",
    style: {
      fill: "#141414"
    },
    cx: 129.6,
    cy: -14.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 60.1473 97.61)",
    style: {
      fill: "#141414"
    },
    cx: 127,
    cy: -10.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 56.2674 96.9395)",
    style: {
      fill: "#141414"
    },
    cx: 124.4,
    cy: -7.4,
    rx: 1.9,
    ry: 1.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M120.4-4.9c-0.6,0.8-0.4,1.9,0.4,2.5s1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 S120.9-5.7,120.4-4.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M117.9-1.3c-0.5,0.7-0.4,1.7,0.3,2.2c0.7,0.5,1.7,0.4,2.2-0.3c0.5-0.7,0.4-1.7-0.3-2.2 C119.4-2.2,118.4-2,117.9-1.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 116.6,
    cy: 3.2,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 40.7478 94.2576)",
    style: {
      fill: "#141414"
    },
    cx: 113.9,
    cy: 6.7,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 36.8679 93.5872)",
    style: {
      fill: "#141414"
    },
    cx: 111.3,
    cy: 10.2,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 32.988 92.9167)",
    style: {
      fill: "#141414"
    },
    cx: 108.7,
    cy: 13.7,
    rx: 1.1,
    ry: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 106.1,
    cy: 17.2,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 103.5,
    cy: 20.7,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M100.4,23.8c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1c0.2-0.3,0.2-0.8-0.1-1 C101,23.5,100.6,23.5,100.4,23.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M97.8,27.4c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C98.4,27.1,98,27.1,97.8,27.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M95.3,31c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 S95.5,30.8,95.3,31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 93.1,
    cy: 34.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 90.5,
    cy: 38.3,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 87.9,
    cy: 41.8,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 85.3,
    cy: 45.4,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -5.8111 86.212)",
    style: {
      fill: "#141414"
    },
    cx: 82.7,
    cy: 48.9,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 80.1,
    cy: 52.4,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 77.5,
    cy: 55.9,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 66.6376 94.7358)",
    style: {
      fill: "#141414"
    },
    cx: 127.4,
    cy: -18.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 124.8,
    cy: -15.3,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M120.6-12.9c-0.6,0.9-0.5,2.1,0.4,2.7c0.9,0.6,2.1,0.5,2.7-0.4c0.6-0.9,0.5-2.1-0.4-2.7 C122.4-13.9,121.2-13.7,120.6-12.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M118.1-9.3c-0.6,0.8-0.4,1.9,0.4,2.5s1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 S118.7-10.1,118.1-9.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M115.7-5.7C115.1-5,115.3-4,116-3.4c0.7,0.5,1.7,0.4,2.2-0.3c0.5-0.7,0.4-1.7-0.3-2.2 C117.2-6.5,116.2-6.4,115.7-5.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 47.2381 91.3834)",
    style: {
      fill: "#141414"
    },
    cx: 114.3,
    cy: -1.2,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 43.3582 90.713)",
    style: {
      fill: "#141414"
    },
    cx: 111.7,
    cy: 2.3,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 39.4783 90.0425)",
    style: {
      fill: "#141414"
    },
    cx: 109.1,
    cy: 5.8,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 106.5,
    cy: 9.3,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 31.7185 88.7016)",
    style: {
      fill: "#141414"
    },
    cx: 103.9,
    cy: 12.9,
    rx: 0.9,
    ry: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M100.6,15.9c-0.3,0.4-0.2,0.9,0.2,1.2c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2 C101.4,15.4,100.9,15.5,100.6,15.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M98.1,19.5c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1s0.2-0.8-0.1-1 C98.8,19.1,98.4,19.2,98.1,19.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M95.6,23.1c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C96.2,22.7,95.8,22.8,95.6,23.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M93.1,26.6c-0.2,0.2-0.1,0.5,0.1,0.7s0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 S93.3,26.4,93.1,26.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 12.319 85.3492)",
    style: {
      fill: "#141414"
    },
    cx: 90.9,
    cy: 30.4,
    rx: 0.4,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M88,33.8c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5 C88.3,33.6,88.1,33.6,88,33.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 85.7,
    cy: 37.5,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 83.1,
    cy: 41,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 80.5,
    cy: 44.5,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 77.9,
    cy: 48,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 75.3,
    cy: 51.5,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -14.8404 80.6559)",
    style: {
      fill: "#141414"
    },
    cx: 72.7,
    cy: 55.1,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 69.248 91.1911)",
    style: {
      fill: "#141414"
    },
    cx: 125.2,
    cy: -23.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 65.3681 90.5206)",
    style: {
      fill: "#141414"
    },
    cx: 122.5,
    cy: -19.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 61.4882 89.8502)",
    style: {
      fill: "#141414"
    },
    cx: 119.9,
    cy: -16.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 57.6083 89.1797)",
    style: {
      fill: "#141414"
    },
    cx: 117.3,
    cy: -12.6,
    rx: 1.9,
    ry: 1.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M113.3-10.1c-0.6,0.8-0.4,1.9,0.4,2.5s1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 S113.9-10.9,113.3-10.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M110.8-6.5c-0.5,0.7-0.4,1.7,0.3,2.3s1.7,0.4,2.3-0.3c0.5-0.7,0.4-1.7-0.3-2.3 S111.4-7.3,110.8-6.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 109.5,
    cy: -2.1,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 106.9,
    cy: 1.5,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 104.3,
    cy: 5,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 34.3289 85.1569)",
    style: {
      fill: "#141414"
    },
    cx: 101.7,
    cy: 8.5,
    rx: 1.1,
    ry: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 99.1,
    cy: 12,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 26.5691 83.8159)",
    style: {
      fill: "#141414"
    },
    cx: 96.5,
    cy: 15.5,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 22.6892 83.1455)",
    style: {
      fill: "#141414"
    },
    cx: 93.9,
    cy: 19,
    rx: 0.7,
    ry: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M90.8,22.2c-0.2,0.3-0.1,0.7,0.1,0.9c0.3,0.2,0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 C91.4,21.9,91,21.9,90.8,22.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M88.3,25.8c-0.2,0.2-0.1,0.6,0.1,0.7c0.2,0.2,0.6,0.1,0.7-0.1c0.2-0.2,0.1-0.6-0.1-0.7 C88.8,25.5,88.4,25.5,88.3,25.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M85.7,29.3c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1s0.1-0.5-0.1-0.6 C86.1,29.1,85.9,29.1,85.7,29.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 83.5,
    cy: 33.1,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 80.9,
    cy: 36.6,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -0.5902 79.1227)",
    style: {
      fill: "#141414"
    },
    cx: 78.3,
    cy: 40.1,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 75.6,
    cy: 43.7,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -8.35 77.7817)",
    style: {
      fill: "#141414"
    },
    cx: 73,
    cy: 47.2,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 70.4,
    cy: 50.7,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 67.9786 86.976)",
    style: {
      fill: "#141414"
    },
    cx: 120.3,
    cy: -24,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 117.7,
    cy: -20.5,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M113.6-18.1c-0.6,0.9-0.5,2.1,0.4,2.7c0.9,0.6,2.1,0.5,2.7-0.4c0.6-0.9,0.5-2.1-0.4-2.7 C115.4-19.2,114.2-19,113.6-18.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M111.1-14.5c-0.6,0.8-0.4,1.9,0.4,2.5s1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 C112.8-15.5,111.7-15.3,111.1-14.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M108.6-10.9c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3c0.5-0.7,0.4-1.8-0.3-2.3 C110.2-11.8,109.1-11.6,108.6-10.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M106.1-7.3c-0.5,0.7-0.4,1.6,0.3,2.1s1.6,0.4,2.1-0.3c0.5-0.7,0.4-1.6-0.3-2.1 S106.6-8,106.1-7.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 104.7,
    cy: -2.9,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 102.1,
    cy: 0.6,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 99.5,
    cy: 4.1,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 33.0594 80.9417)",
    style: {
      fill: "#141414"
    },
    cx: 96.9,
    cy: 7.7,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M93.6,10.7c-0.3,0.4-0.2,0.9,0.2,1.2c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2 C94.4,10.2,93.9,10.3,93.6,10.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M91.1,14.2c-0.2,0.3-0.2,0.8,0.2,1.1c0.3,0.2,0.8,0.2,1.1-0.2c0.2-0.3,0.2-0.8-0.2-1.1 C91.8,13.8,91.3,13.9,91.1,14.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M88.6,17.8c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 C89.2,17.5,88.8,17.5,88.6,17.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M86,21.4c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 S86.2,21.1,86,21.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M83.5,25c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 C83.9,24.7,83.6,24.8,83.5,25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 81.3,
    cy: 28.8,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 78.6,
    cy: 32.3,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 76,
    cy: 35.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 73.4,
    cy: 39.3,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 70.8,
    cy: 42.8,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 68.2,
    cy: 46.3,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 65.6,
    cy: 49.8,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -17.3793 72.2257)",
    style: {
      fill: "#141414"
    },
    cx: 63,
    cy: 53.4,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 70.589 83.4313)",
    style: {
      fill: "#141414"
    },
    cx: 118.1,
    cy: -28.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 66.7091 82.7608)",
    style: {
      fill: "#141414"
    },
    cx: 115.5,
    cy: -24.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 62.8292 82.0903)",
    style: {
      fill: "#141414"
    },
    cx: 112.9,
    cy: -21.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 110.3,
    cy: -17.8,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M106.2-15.4c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 C108-16.3,106.8-16.2,106.2-15.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M103.8-11.8c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3s0.4-1.8-0.3-2.3 C105.3-12.7,104.3-12.5,103.8-11.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M101.3-8.2c-0.5,0.7-0.4,1.6,0.3,2.1c0.7,0.5,1.6,0.4,2.1-0.3s0.4-1.6-0.3-2.1 C102.7-9,101.8-8.8,101.3-8.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 43.4297 78.738)",
    style: {
      fill: "#141414"
    },
    cx: 99.9,
    cy: -3.7,
    rx: 1.4,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 97.3,
    cy: -0.2,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 94.7,
    cy: 3.3,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 31.7899 76.7266)",
    style: {
      fill: "#141414"
    },
    cx: 92.1,
    cy: 6.8,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 27.91 76.0561)",
    style: {
      fill: "#141414"
    },
    cx: 89.5,
    cy: 10.3,
    rx: 0.9,
    ry: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M86.2,13.4c-0.3,0.3-0.2,0.8,0.2,1.1c0.3,0.3,0.8,0.2,1.1-0.2c0.3-0.3,0.2-0.8-0.2-1.1 C87,13,86.5,13,86.2,13.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M83.7,17c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1s0.2-0.7-0.1-0.9 C84.4,16.6,83.9,16.7,83.7,17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M81.2,20.5c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C81.7,20.2,81.4,20.3,81.2,20.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 79,
    cy: 24.4,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 76.4,
    cy: 27.9,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 4.6306 72.0333)",
    style: {
      fill: "#141414"
    },
    cx: 73.8,
    cy: 31.4,
    rx: 0.3,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 71.2,
    cy: 34.9,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 68.6,
    cy: 38.5,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -7.0091 70.0219)",
    style: {
      fill: "#141414"
    },
    cx: 66,
    cy: 42,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 63.4,
    cy: 45.5,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 60.8,
    cy: 49,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -18.6488 68.0105)",
    style: {
      fill: "#141414"
    },
    cx: 58.2,
    cy: 52.5,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 69.3195 79.2161)",
    style: {
      fill: "#141414"
    },
    cx: 113.3,
    cy: -29.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 65.4396 78.5457)",
    style: {
      fill: "#141414"
    },
    cx: 110.7,
    cy: -25.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M106.5-23.4c-0.7,0.9-0.5,2.1,0.4,2.8s2.1,0.5,2.8-0.4s0.5-2.1-0.4-2.8 C108.4-24.4,107.1-24.3,106.5-23.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 57.6798 77.2047)",
    style: {
      fill: "#141414"
    },
    cx: 105.5,
    cy: -18.7,
    rx: 1.8,
    ry: 1.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M101.5-16.2c-0.6,0.8-0.4,1.8,0.4,2.4c0.8,0.6,1.8,0.4,2.4-0.4s0.4-1.8-0.4-2.4 C103.1-17.1,102.1-16.9,101.5-16.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M99-12.6c-0.5,0.7-0.4,1.7,0.3,2.2c0.7,0.5,1.7,0.4,2.2-0.3s0.4-1.7-0.3-2.2 C100.5-13.4,99.5-13.2,99-12.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 46.0401 75.1933)",
    style: {
      fill: "#141414"
    },
    cx: 97.7,
    cy: -8.1,
    rx: 1.4,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 42.1602 74.5229)",
    style: {
      fill: "#141414"
    },
    cx: 95.1,
    cy: -4.6,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 92.5,
    cy: -1.1,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 89.9,
    cy: 2.4,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 87.2,
    cy: 6,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M84,9c-0.3,0.4-0.2,0.9,0.2,1.1c0.4,0.3,0.9,0.2,1.1-0.2c0.3-0.4,0.2-0.9-0.2-1.1 C84.8,8.6,84.3,8.6,84,9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M81.5,12.6c-0.2,0.3-0.2,0.7,0.1,1c0.3,0.2,0.7,0.2,1-0.1c0.2-0.3,0.2-0.7-0.1-1 C82.1,12.2,81.7,12.3,81.5,12.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M79,16.2c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1s0.1-0.6-0.1-0.8 C79.5,15.8,79.1,15.9,79,16.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M76.4,19.7c-0.2,0.2-0.1,0.5,0.1,0.7s0.5,0.1,0.7-0.1s0.1-0.5-0.1-0.7 C76.9,19.4,76.6,19.5,76.4,19.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 11.1209 69.1591)",
    style: {
      fill: "#141414"
    },
    cx: 74.2,
    cy: 23.5,
    rx: 0.4,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M71.3,26.9c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1s0.1-0.4-0.1-0.5 C71.7,26.7,71.5,26.7,71.3,26.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 69,
    cy: 30.6,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -0.5188 67.1477)",
    style: {
      fill: "#141414"
    },
    cx: 66.4,
    cy: 34.1,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 63.8,
    cy: 37.6,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 61.2,
    cy: 41.1,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 58.6,
    cy: 44.6,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 56,
    cy: 48.2,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -19.9183 63.7954)",
    style: {
      fill: "#141414"
    },
    cx: 53.4,
    cy: 51.7,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 71.9299 75.6715)",
    style: {
      fill: "#141414"
    },
    cx: 111.1,
    cy: -33.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 68.05 75.001)",
    style: {
      fill: "#141414"
    },
    cx: 108.5,
    cy: -30.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 64.1701 74.3305)",
    style: {
      fill: "#141414"
    },
    cx: 105.9,
    cy: -26.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 103.3,
    cy: -23,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M99.2-20.6c-0.6,0.8-0.4,2,0.4,2.6c0.8,0.6,2,0.4,2.6-0.4c0.6-0.8,0.4-2-0.4-2.6 C101-21.6,99.8-21.5,99.2-20.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M96.7-17c-0.6,0.8-0.4,1.8,0.4,2.4c0.8,0.6,1.8,0.4,2.4-0.4s0.4-1.8-0.4-2.4 C98.3-17.9,97.2-17.8,96.7-17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 95.5,
    cy: -12.5,
    r: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 92.8,
    cy: -9,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 90.2,
    cy: -5.4,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 37.0108 69.6373)",
    style: {
      fill: "#141414"
    },
    cx: 87.6,
    cy: -1.9,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 85,
    cy: 1.6,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 29.251 68.2963)",
    style: {
      fill: "#141414"
    },
    cx: 82.4,
    cy: 5.1,
    rx: 0.9,
    ry: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 25.3711 67.6259)",
    style: {
      fill: "#141414"
    },
    cx: 79.8,
    cy: 8.6,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 21.4912 66.9554)",
    style: {
      fill: "#141414"
    },
    cx: 77.2,
    cy: 12.1,
    rx: 0.7,
    ry: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M74.1,15.3c-0.2,0.3-0.1,0.7,0.1,0.9c0.3,0.2,0.7,0.1,0.9-0.1c0.2-0.3,0.1-0.7-0.1-0.9 C74.7,14.9,74.3,15,74.1,15.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M71.6,18.9c-0.2,0.2-0.1,0.6,0.1,0.8s0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 S71.7,18.6,71.6,18.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M69,22.4c-0.2,0.2-0.1,0.5,0.1,0.6c0.2,0.2,0.5,0.1,0.6-0.1c0.2-0.2,0.1-0.5-0.1-0.6 C69.5,22.2,69.2,22.2,69,22.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M66.5,26c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5 C66.9,25.8,66.6,25.8,66.5,26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 64.2,
    cy: 29.7,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 61.6,
    cy: 33.2,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 59,
    cy: 36.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 56.4,
    cy: 40.3,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -13.428 60.9212)",
    style: {
      fill: "#141414"
    },
    cx: 53.8,
    cy: 43.8,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 51.2,
    cy: 47.3,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 48.6,
    cy: 50.8,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -25.0677 58.9098)",
    style: {
      fill: "#141414"
    },
    cx: 45.9,
    cy: 54.3,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 70.6604 71.4563)",
    style: {
      fill: "#141414"
    },
    cx: 106.3,
    cy: -34.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 66.7805 70.7859)",
    style: {
      fill: "#141414"
    },
    cx: 103.7,
    cy: -30.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 101.1,
    cy: -27.4,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M96.9-25c-0.6,0.9-0.5,2.1,0.4,2.7c0.9,0.6,2.1,0.5,2.7-0.4c0.6-0.9,0.5-2.1-0.4-2.7 C98.7-26,97.5-25.9,96.9-25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M94.4-21.4c-0.6,0.8-0.4,1.9,0.4,2.5s1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 C96.1-22.4,95-22.2,94.4-21.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M91.9-17.8c-0.5,0.7-0.4,1.7,0.3,2.3c0.7,0.5,1.7,0.4,2.3-0.3c0.5-0.7,0.4-1.7-0.3-2.3 C93.5-18.7,92.5-18.5,91.9-17.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M89.4-14.2c-0.5,0.7-0.4,1.6,0.3,2.1s1.6,0.4,2.1-0.3c0.5-0.7,0.4-1.6-0.3-2.1 S89.9-14.9,89.4-14.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 88,
    cy: -9.8,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 85.4,
    cy: -6.3,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 35.7413 65.4221)",
    style: {
      fill: "#141414"
    },
    cx: 82.8,
    cy: -2.8,
    rx: 1.1,
    ry: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 80.2,
    cy: 0.7,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 77.6,
    cy: 4.3,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 24.1016 63.4107)",
    style: {
      fill: "#141414"
    },
    cx: 75,
    cy: 7.8,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M71.9,10.9c-0.2,0.3-0.2,0.7,0.1,1c0.3,0.2,0.7,0.2,1-0.1c0.2-0.3,0.2-0.7-0.1-1 C72.5,10.5,72.1,10.6,71.9,10.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M69.3,14.5c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1s0.1-0.6-0.1-0.8 C69.9,14.2,69.5,14.2,69.3,14.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M66.8,18c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C67.3,17.8,66.9,17.8,66.8,18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 8.582 60.7289)",
    style: {
      fill: "#141414"
    },
    cx: 64.6,
    cy: 21.8,
    rx: 0.4,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M61.7,25.2c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5 C62,25,61.8,25,61.7,25.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 59.4,
    cy: 28.9,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 56.8,
    cy: 32.4,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 54.2,
    cy: 35.9,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -10.8175 57.3765)",
    style: {
      fill: "#141414"
    },
    cx: 51.6,
    cy: 39.4,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 48.9,
    cy: 42.9,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 46.3,
    cy: 46.5,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 43.7,
    cy: 50,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 41.1,
    cy: 53.5,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -30.2171 54.0242)",
    style: {
      fill: "#141414"
    },
    cx: 38.5,
    cy: 57,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -53.4965 50.0014)",
    style: {
      fill: "#141414"
    },
    cx: 22.9,
    cy: 78.1,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 20.3,
    cy: 81.6,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 73.2709 67.9117)",
    style: {
      fill: "#141414"
    },
    cx: 104.1,
    cy: -38.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 69.3909 67.2412)",
    style: {
      fill: "#141414"
    },
    cx: 101.4,
    cy: -35.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 65.511 66.5707)",
    style: {
      fill: "#141414"
    },
    cx: 98.8,
    cy: -31.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 61.6311 65.9003)",
    style: {
      fill: "#141414"
    },
    cx: 96.2,
    cy: -28.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 93.6,
    cy: -24.7,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M89.6-22.3c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 S90.2-23.1,89.6-22.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M87.1-18.7c-0.6,0.7-0.4,1.8,0.3,2.3c0.7,0.6,1.8,0.4,2.3-0.3s0.4-1.8-0.3-2.3 C88.7-19.6,87.6-19.4,87.1-18.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M84.6-15.1c-0.5,0.7-0.4,1.6,0.3,2.2c0.7,0.5,1.6,0.4,2.2-0.3s0.4-1.6-0.3-2.2 C86.1-15.9,85.1-15.8,84.6-15.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 42.2316 62.5479)",
    style: {
      fill: "#141414"
    },
    cx: 83.2,
    cy: -10.7,
    rx: 1.4,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 38.3517 61.8775)",
    style: {
      fill: "#141414"
    },
    cx: 80.6,
    cy: -7.1,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 78,
    cy: -3.6,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 75.4,
    cy: -0.1,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 72.8,
    cy: 3.4,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M69.5,6.4c-0.3,0.4-0.2,0.9,0.2,1.2c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2 C70.3,6,69.8,6.1,69.5,6.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 18.9522 58.5251)",
    style: {
      fill: "#141414"
    },
    cx: 67.6,
    cy: 10.4,
    rx: 0.7,
    ry: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M64.5,13.6c-0.2,0.3-0.1,0.7,0.1,0.9s0.7,0.1,0.9-0.1c0.2-0.3,0.1-0.7-0.1-0.9 C65.1,13.2,64.7,13.3,64.5,13.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M61.9,17.2c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1s0.1-0.6-0.1-0.8 C62.4,16.9,62.1,16.9,61.9,17.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M59.4,20.7c-0.2,0.2-0.1,0.5,0.1,0.6c0.2,0.2,0.5,0.1,0.6-0.1c0.2-0.2,0.1-0.5-0.1-0.6 C59.8,20.5,59.5,20.5,59.4,20.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 57.2,
    cy: 24.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 54.5,
    cy: 28,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 51.9,
    cy: 31.5,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 49.3,
    cy: 35.1,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 46.7,
    cy: 38.6,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 44.1,
    cy: 42.1,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -19.8468 51.8204)",
    style: {
      fill: "#141414"
    },
    cx: 41.5,
    cy: 45.6,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 38.9,
    cy: 49.1,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 36.3,
    cy: 52.6,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 33.7,
    cy: 56.2,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 31.1,
    cy: 59.7,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 28.5,
    cy: 63.2,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 25.9,
    cy: 66.7,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 23.3,
    cy: 70.2,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 20.7,
    cy: 73.7,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 18.1,
    cy: 77.3,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 15.5,
    cy: 80.8,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 72.0014 63.6965)",
    style: {
      fill: "#141414"
    },
    cx: 99.2,
    cy: -39.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 68.1215 63.0261)",
    style: {
      fill: "#141414"
    },
    cx: 96.6,
    cy: -36.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 64.2416 62.3556)",
    style: {
      fill: "#141414"
    },
    cx: 94,
    cy: -32.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 91.4,
    cy: -29.1,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M87.3-26.7c-0.6,0.8-0.4,2,0.4,2.6c0.8,0.6,2,0.4,2.6-0.4c0.6-0.8,0.4-2-0.4-2.6 C89.1-27.7,87.9-27.5,87.3-26.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M84.8-23.1c-0.6,0.8-0.4,1.8,0.4,2.4c0.8,0.6,1.8,0.4,2.4-0.4c0.6-0.8,0.4-1.8-0.4-2.4 S85.4-23.8,84.8-23.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 83.6,
    cy: -18.5,
    r: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 81,
    cy: -15,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 40.9621 58.3328)",
    style: {
      fill: "#141414"
    },
    cx: 78.4,
    cy: -11.5,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 37.0822 57.6623)",
    style: {
      fill: "#141414"
    },
    cx: 75.8,
    cy: -8,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 73.2,
    cy: -4.5,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 70.6,
    cy: -0.9,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 68,
    cy: 2.6,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 21.5626 54.9805)",
    style: {
      fill: "#141414"
    },
    cx: 65.4,
    cy: 6.1,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M62.2,9.2c-0.2,0.3-0.2,0.7,0.1,1c0.3,0.2,0.7,0.2,1-0.1c0.2-0.3,0.2-0.7-0.1-1 C62.9,8.8,62.4,8.9,62.2,9.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M59.7,12.8c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1s0.1-0.6-0.1-0.8 C60.2,12.4,59.9,12.5,59.7,12.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M57.1,16.3c-0.2,0.2-0.1,0.6,0.1,0.7c0.2,0.2,0.6,0.1,0.7-0.1s0.1-0.6-0.1-0.7 C57.6,16,57.3,16.1,57.1,16.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M54.6,19.9c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 C55,19.6,54.7,19.7,54.6,19.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M52,23.4c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5 C52.4,23.2,52.2,23.3,52,23.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -1.7168 50.9576)",
    style: {
      fill: "#141414"
    },
    cx: 49.7,
    cy: 27.2,
    rx: 0.3,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 47.1,
    cy: 30.7,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 44.5,
    cy: 34.2,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 41.9,
    cy: 37.7,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 39.3,
    cy: 41.2,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 36.7,
    cy: 44.8,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -24.9962 46.9348)",
    style: {
      fill: "#141414"
    },
    cx: 34.1,
    cy: 48.3,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 31.5,
    cy: 51.8,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 28.9,
    cy: 55.3,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 26.3,
    cy: 58.8,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 23.7,
    cy: 62.3,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 21.1,
    cy: 65.9,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 18.5,
    cy: 69.4,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 15.9,
    cy: 72.9,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 13.3,
    cy: 76.4,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 74.6118 60.1519)",
    style: {
      fill: "#141414"
    },
    cx: 97,
    cy: -44,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 70.7319 59.4814)",
    style: {
      fill: "#141414"
    },
    cx: 94.4,
    cy: -40.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 66.852 58.8109)",
    style: {
      fill: "#141414"
    },
    cx: 91.8,
    cy: -37,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 62.9721 58.1405)",
    style: {
      fill: "#141414"
    },
    cx: 89.2,
    cy: -33.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 86.6,
    cy: -29.9,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 55.2123 56.7995)",
    style: {
      fill: "#141414"
    },
    cx: 84,
    cy: -26.4,
    rx: 1.9,
    ry: 1.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M80-24c-0.6,0.8-0.4,1.9,0.4,2.5s1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 C81.7-24.9,80.5-24.8,80-24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M77.5-20.4c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3s0.4-1.8-0.3-2.3 C79-21.2,78-21.1,77.5-20.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M75-16.8c-0.5,0.7-0.4,1.6,0.3,2.1c0.7,0.5,1.6,0.4,2.1-0.3c0.5-0.7,0.4-1.6-0.3-2.1 C76.4-17.6,75.5-17.4,75-16.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 39.6927 54.1177)",
    style: {
      fill: "#141414"
    },
    cx: 73.6,
    cy: -12.3,
    rx: 1.4,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 35.8127 53.4472)",
    style: {
      fill: "#141414"
    },
    cx: 71,
    cy: -8.8,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 68.4,
    cy: -5.3,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 65.8,
    cy: -1.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 63.1,
    cy: 1.7,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 20.2931 50.7653)",
    style: {
      fill: "#141414"
    },
    cx: 60.5,
    cy: 5.2,
    rx: 0.8,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M57.3,8.3c-0.2,0.3-0.2,0.8,0.2,1c0.3,0.2,0.8,0.2,1-0.2c0.2-0.3,0.2-0.8-0.2-1 C58.1,7.9,57.6,8,57.3,8.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M54.8,11.9c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 C55.4,11.5,55,11.6,54.8,11.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M52.3,15.4c-0.2,0.3-0.1,0.6,0.1,0.8s0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 S52.5,15.2,52.3,15.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M49.7,19c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 S49.9,18.8,49.7,19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M47.2,22.6c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 C47.6,22.3,47.3,22.4,47.2,22.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M44.6,26.1c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1s0.1-0.4-0.1-0.5 C45,25.9,44.7,25.9,44.6,26.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -6.8662 46.072)",
    style: {
      fill: "#141414"
    },
    cx: 42.3,
    cy: 29.9,
    rx: 0.3,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 39.7,
    cy: 33.4,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -14.626 44.7311)",
    style: {
      fill: "#141414"
    },
    cx: 37.1,
    cy: 36.9,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 34.5,
    cy: 40.4,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 31.9,
    cy: 43.9,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 29.3,
    cy: 47.4,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -30.1456 42.0492)",
    style: {
      fill: "#141414"
    },
    cx: 26.7,
    cy: 51,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 24.1,
    cy: 54.5,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 21.5,
    cy: 58,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -41.7853 40.0378)",
    style: {
      fill: "#141414"
    },
    cx: 18.9,
    cy: 61.5,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -45.6652 39.3674)",
    style: {
      fill: "#141414"
    },
    cx: 16.2,
    cy: 65,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 13.6,
    cy: 68.5,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -53.425 38.0264)",
    style: {
      fill: "#141414"
    },
    cx: 11,
    cy: 72.1,
    rx: 0.1,
    ry: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 8.4,
    cy: 75.6,
    r: 0.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 73.3423 55.9367)",
    style: {
      fill: "#141414"
    },
    cx: 92.2,
    cy: -44.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 69.4624 55.2663)",
    style: {
      fill: "#141414"
    },
    cx: 89.6,
    cy: -41.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 65.5825 54.5958)",
    style: {
      fill: "#141414"
    },
    cx: 87,
    cy: -37.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 61.7026 53.9253)",
    style: {
      fill: "#141414"
    },
    cx: 84.4,
    cy: -34.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 81.8,
    cy: -30.8,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M77.7-28.4c-0.6,0.8-0.4,2,0.4,2.6c0.8,0.6,2,0.4,2.6-0.4c0.6-0.8,0.4-2-0.4-2.6 C79.5-29.4,78.3-29.2,77.7-28.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M75.2-24.8c-0.6,0.8-0.4,1.8,0.4,2.4c0.8,0.6,1.8,0.4,2.4-0.4c0.6-0.8,0.4-1.8-0.4-2.4 C76.8-25.7,75.8-25.5,75.2-24.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M72.7-21.2c-0.5,0.7-0.4,1.7,0.3,2.2c0.7,0.5,1.7,0.4,2.2-0.3c0.5-0.7,0.4-1.7-0.3-2.2 C74.2-22,73.2-21.9,72.7-21.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 71.4,
    cy: -16.7,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 68.8,
    cy: -13.2,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 34.5433 49.2321)",
    style: {
      fill: "#141414"
    },
    cx: 66.1,
    cy: -9.7,
    rx: 1.2,
    ry: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 30.6634 48.5616)",
    style: {
      fill: "#141414"
    },
    cx: 63.5,
    cy: -6.2,
    rx: 1.1,
    ry: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 60.9,
    cy: -2.6,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 58.3,
    cy: 0.9,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 55.7,
    cy: 4.4,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 15.1437 45.8797)",
    style: {
      fill: "#141414"
    },
    cx: 53.1,
    cy: 7.9,
    rx: 0.7,
    ry: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M50,11c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 C50.6,10.7,50.2,10.8,50,11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M47.5,14.6c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C48,14.3,47.6,14.3,47.5,14.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M44.9,18.2c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C45.4,17.9,45.1,17.9,44.9,18.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M42.3,21.7c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 C42.8,21.5,42.5,21.5,42.3,21.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 40.1,
    cy: 25.5,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M37.2,28.8c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1s0.1-0.4-0.1-0.5 C37.5,28.6,37.3,28.7,37.2,28.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 34.9,
    cy: 32.5,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 32.3,
    cy: 36,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 29.7,
    cy: 39.6,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -23.6553 39.175)",
    style: {
      fill: "#141414"
    },
    cx: 27.1,
    cy: 43.1,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 24.5,
    cy: 46.6,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 21.9,
    cy: 50.1,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 19.2,
    cy: 53.6,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 16.6,
    cy: 57.1,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 14,
    cy: 60.7,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 11.4,
    cy: 64.2,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 8.8,
    cy: 67.7,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 6.2,
    cy: 71.2,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 75.9527 52.3921)",
    style: {
      fill: "#141414"
    },
    cx: 90,
    cy: -49.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 72.0728 51.7216)",
    style: {
      fill: "#141414"
    },
    cx: 87.4,
    cy: -45.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 68.1929 51.0511)",
    style: {
      fill: "#141414"
    },
    cx: 84.8,
    cy: -42.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 64.313 50.3807)",
    style: {
      fill: "#141414"
    },
    cx: 82.2,
    cy: -38.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 60.4331 49.7102)",
    style: {
      fill: "#141414"
    },
    cx: 79.6,
    cy: -35.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 56.5532 49.0397)",
    style: {
      fill: "#141414"
    },
    cx: 77,
    cy: -31.6,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M72.8-29.2c-0.6,0.9-0.5,2.1,0.4,2.7c0.9,0.6,2.1,0.5,2.7-0.4c0.6-0.9,0.5-2.1-0.4-2.7 C74.6-30.3,73.4-30.1,72.8-29.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M70.3-25.7c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 C72-26.6,70.9-26.4,70.3-25.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M67.8-22.1c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3s0.4-1.8-0.3-2.3 C69.4-22.9,68.4-22.8,67.8-22.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 66.5,
    cy: -17.6,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 37.1537 45.6874)",
    style: {
      fill: "#141414"
    },
    cx: 63.9,
    cy: -14,
    rx: 1.4,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 61.3,
    cy: -10.5,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 58.7,
    cy: -7,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 25.514 43.676)",
    style: {
      fill: "#141414"
    },
    cx: 56.1,
    cy: -3.5,
    rx: 1.1,
    ry: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 53.5,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 17.7542 42.335)",
    style: {
      fill: "#141414"
    },
    cx: 50.9,
    cy: 3.5,
    rx: 0.9,
    ry: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M47.7,6.6c-0.3,0.4-0.2,0.9,0.2,1.1c0.4,0.3,0.9,0.2,1.1-0.2c0.3-0.4,0.2-0.9-0.2-1.1 C48.4,6.2,47.9,6.2,47.7,6.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M45.1,10.1c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1c0.2-0.3,0.2-0.8-0.1-1 C45.8,9.8,45.4,9.8,45.1,10.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M42.6,13.7c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 C43.2,13.4,42.8,13.4,42.6,13.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M40,17.3c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C40.6,17,40.2,17,40,17.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M37.5,20.8c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1s0.1-0.5-0.1-0.7 S37.6,20.6,37.5,20.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M34.9,24.4c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 C35.3,24.1,35.1,24.2,34.9,24.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M32.3,27.9c-0.1,0.2-0.1,0.4,0.1,0.6c0.2,0.1,0.4,0.1,0.6-0.1s0.1-0.4-0.1-0.6 C32.7,27.7,32.5,27.7,32.3,27.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 30.1,
    cy: 31.7,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 27.5,
    cy: 35.2,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 24.8,
    cy: 38.7,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 22.2,
    cy: 42.2,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 19.6,
    cy: 45.7,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -32.6846 33.619)",
    style: {
      fill: "#141414"
    },
    cx: 17,
    cy: 49.3,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 14.4,
    cy: 52.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 11.8,
    cy: 56.3,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 9.2,
    cy: 59.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -48.2042 30.9371)",
    style: {
      fill: "#141414"
    },
    cx: 6.6,
    cy: 63.3,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 4,
    cy: 66.8,
    r: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 1.4,
    cy: 70.4,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 74.6832 48.1769)",
    style: {
      fill: "#141414"
    },
    cx: 85.2,
    cy: -50.1,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 70.8033 47.5065)",
    style: {
      fill: "#141414"
    },
    cx: 82.6,
    cy: -46.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 66.9234 46.836)",
    style: {
      fill: "#141414"
    },
    cx: 80,
    cy: -43,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 63.0435 46.1655)",
    style: {
      fill: "#141414"
    },
    cx: 77.4,
    cy: -39.5,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 74.7,
    cy: -36,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M70.5-33.7c-0.7,0.9-0.5,2.1,0.4,2.8c0.9,0.7,2.1,0.5,2.8-0.4c0.7-0.9,0.5-2.1-0.4-2.8 S71.2-34.6,70.5-33.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M68-30.1c-0.6,0.8-0.4,2,0.4,2.6c0.8,0.6,2,0.4,2.6-0.4s0.4-2-0.4-2.6 C69.8-31.1,68.7-30.9,68-30.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M65.5-26.5c-0.6,0.8-0.4,1.8,0.4,2.4c0.8,0.6,1.8,0.4,2.4-0.4c0.6-0.8,0.4-1.8-0.4-2.4 C67.2-27.4,66.1-27.2,65.5-26.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M63-22.9c-0.5,0.7-0.4,1.7,0.3,2.2c0.7,0.5,1.7,0.4,2.2-0.3c0.5-0.7,0.4-1.7-0.3-2.2 C64.6-23.7,63.6-23.6,63-22.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 61.7,
    cy: -18.4,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 59.1,
    cy: -14.9,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 56.5,
    cy: -11.4,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 53.9,
    cy: -7.9,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 24.2445 39.4608)",
    style: {
      fill: "#141414"
    },
    cx: 51.3,
    cy: -4.3,
    rx: 1.1,
    ry: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 48.7,
    cy: -0.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 46.1,
    cy: 2.7,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M42.8,5.7c-0.3,0.4-0.2,0.9,0.2,1.1c0.4,0.3,0.9,0.2,1.1-0.2c0.3-0.4,0.2-0.9-0.2-1.1 C43.6,5.3,43.1,5.4,42.8,5.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M40.3,9.3c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1c0.2-0.3,0.2-0.8-0.1-1 C41,8.9,40.5,9,40.3,9.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M37.7,12.9c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 C38.4,12.5,38,12.6,37.7,12.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M35.2,16.4c-0.2,0.3-0.1,0.6,0.1,0.8s0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 S35.4,16.2,35.2,16.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -2.9148 34.7676)",
    style: {
      fill: "#141414"
    },
    cx: 33.1,
    cy: 20.3,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M30.1,23.5c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1s0.1-0.5-0.1-0.7 C30.5,23.2,30.2,23.3,30.1,23.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M27.5,27.1c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1s0.1-0.5-0.1-0.6 C27.9,26.8,27.6,26.9,27.5,27.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M24.9,30.6c-0.1,0.2-0.1,0.4,0.1,0.6c0.2,0.1,0.4,0.1,0.6-0.1c0.1-0.2,0.1-0.4-0.1-0.6 C25.3,30.4,25.1,30.4,24.9,30.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 22.6,
    cy: 34.3,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M19.8,37.7c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5 C20.1,37.5,19.9,37.5,19.8,37.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -26.1943 30.7448)",
    style: {
      fill: "#141414"
    },
    cx: 17.4,
    cy: 41.4,
    rx: 0.3,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 14.8,
    cy: 44.9,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 12.2,
    cy: 48.4,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 9.6,
    cy: 51.9,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 7,
    cy: 55.4,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 4.4,
    cy: 59,
    r: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -49.4737 26.722)",
    style: {
      fill: "#141414"
    },
    cx: 1.8,
    cy: 62.5,
    rx: 0.3,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M-1.1,65.8c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1s0.1-0.4-0.1-0.5 C-0.8,65.6-1,65.6-1.1,65.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 77.2937 44.6322)",
    style: {
      fill: "#141414"
    },
    cx: 83,
    cy: -54.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 73.4138 43.9618)",
    style: {
      fill: "#141414"
    },
    cx: 80.4,
    cy: -50.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 69.5339 43.2913)",
    style: {
      fill: "#141414"
    },
    cx: 77.7,
    cy: -47.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 65.6539 42.6208)",
    style: {
      fill: "#141414"
    },
    cx: 75.1,
    cy: -43.9,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 61.774 41.9504)",
    style: {
      fill: "#141414"
    },
    cx: 72.5,
    cy: -40.4,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 57.8941 41.2799)",
    style: {
      fill: "#141414"
    },
    cx: 69.9,
    cy: -36.8,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 67.3,
    cy: -33.3,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M63.2-31c-0.6,0.9-0.5,2.1,0.4,2.7c0.9,0.6,2.1,0.5,2.7-0.4s0.5-2.1-0.4-2.7 C65-32,63.8-31.8,63.2-31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M60.7-27.4c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4s0.4-1.9-0.4-2.5 C62.4-28.3,61.3-28.2,60.7-27.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M58.2-23.8c-0.6,0.7-0.4,1.8,0.4,2.4s1.8,0.4,2.4-0.4s0.4-1.8-0.4-2.4 C59.8-24.7,58.7-24.5,58.2-23.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 56.9,
    cy: -19.3,
    r: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 54.3,
    cy: -15.7,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 51.7,
    cy: -12.2,
    r: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 49.1,
    cy: -8.7,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 46.5,
    cy: -5.2,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 43.9,
    cy: -1.7,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 41.3,
    cy: 1.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 38.7,
    cy: 5.4,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M35.4,8.4c-0.3,0.4-0.2,0.9,0.2,1.1c0.4,0.3,0.9,0.2,1.1-0.2C37,9,36.9,8.5,36.5,8.2 C36.2,8,35.7,8,35.4,8.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M32.9,12c-0.2,0.3-0.2,0.8,0.2,1s0.8,0.2,1-0.2c0.2-0.3,0.2-0.8-0.2-1S33.1,11.6,32.9,12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M30.3,15.5c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 C30.9,15.2,30.5,15.2,30.3,15.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M27.7,19.1c-0.2,0.3-0.1,0.7,0.1,0.9s0.7,0.1,0.9-0.1s0.1-0.7-0.1-0.9 C28.3,18.7,27.9,18.8,27.7,19.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M25.2,22.6c-0.2,0.2-0.1,0.6,0.1,0.8c0.2,0.2,0.6,0.1,0.8-0.1c0.2-0.2,0.1-0.6-0.1-0.8 C25.7,22.3,25.4,22.4,25.2,22.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M22.6,26.2c-0.2,0.2-0.1,0.6,0.1,0.7c0.2,0.2,0.6,0.1,0.7-0.1c0.2-0.2,0.1-0.6-0.1-0.7 C23.1,25.9,22.8,25.9,22.6,26.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M20,29.7c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C20.5,29.4,20.2,29.5,20,29.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M17.5,33.2c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1c0.1-0.2,0.1-0.5-0.1-0.6 C17.9,33,17.6,33,17.5,33.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -23.5838 27.2001)",
    style: {
      fill: "#141414"
    },
    cx: 15.2,
    cy: 37,
    rx: 0.4,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M12.3,40.3c-0.1,0.2-0.1,0.4,0.1,0.6c0.2,0.1,0.4,0.1,0.6-0.1c0.1-0.2,0.1-0.4-0.1-0.6 C12.7,40.1,12.4,40.1,12.3,40.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 10,
    cy: 44,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M7.1,47.3C7,47.5,7,47.7,7.2,47.9C7.3,48,7.6,48,7.7,47.8s0.1-0.4-0.1-0.5 C7.5,47.1,7.2,47.2,7.1,47.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M4.5,50.9c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1c0.1-0.2,0.1-0.4-0.1-0.5 C4.8,50.7,4.6,50.7,4.5,50.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M1.9,54.4c-0.1,0.2-0.1,0.4,0.1,0.5C2.1,55,2.4,55,2.5,54.8s0.1-0.4-0.1-0.5 C2.2,54.2,2,54.2,1.9,54.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M-0.7,57.9c-0.1,0.2-0.1,0.4,0.1,0.5c0.2,0.1,0.4,0.1,0.5-0.1s0.1-0.4-0.1-0.5 C-0.4,57.7-0.6,57.7-0.7,57.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M-3.3,61.4c-0.1,0.2-0.1,0.4,0.1,0.6c0.2,0.1,0.4,0.1,0.6-0.1s0.1-0.4-0.1-0.6 C-3,61.2-3.2,61.2-3.3,61.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: -5.6,
    cy: 65.1,
    r: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 76.0242 40.4171)",
    style: {
      fill: "#141414"
    },
    cx: 78.1,
    cy: -55.3,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 72.1443 39.7466)",
    style: {
      fill: "#141414"
    },
    cx: 75.5,
    cy: -51.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 68.2644 39.0762)",
    style: {
      fill: "#141414"
    },
    cx: 72.9,
    cy: -48.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 64.3845 38.4057)",
    style: {
      fill: "#141414"
    },
    cx: 70.3,
    cy: -44.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 60.5046 37.7352)",
    style: {
      fill: "#141414"
    },
    cx: 67.7,
    cy: -41.2,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 56.6247 37.0648)",
    style: {
      fill: "#141414"
    },
    cx: 65.1,
    cy: -37.7,
    rx: 2.1,
    ry: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 62.5,
    cy: -34.2,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M58.4-31.8c-0.6,0.8-0.4,2,0.4,2.6c0.8,0.6,2,0.4,2.6-0.4c0.6-0.8,0.4-2-0.4-2.6 C60.2-32.8,59-32.6,58.4-31.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M55.9-28.2c-0.6,0.8-0.4,1.9,0.4,2.5c0.8,0.6,1.9,0.4,2.5-0.4c0.6-0.8,0.4-1.9-0.4-2.5 C57.6-29.1,56.5-29,55.9-28.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M53.4-24.6c-0.5,0.7-0.4,1.8,0.3,2.3c0.7,0.5,1.8,0.4,2.3-0.3c0.5-0.7,0.4-1.8-0.3-2.3 S53.9-25.3,53.4-24.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M50.8-21c-0.5,0.7-0.4,1.6,0.3,2.2s1.6,0.4,2.2-0.3s0.4-1.6-0.3-2.2S51.3-21.7,50.8-21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M48.3-17.4c-0.5,0.6-0.3,1.5,0.3,2c0.6,0.5,1.5,0.3,2-0.3c0.5-0.6,0.3-1.5-0.3-2 C49.7-18.2,48.8-18.1,48.3-17.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 29.4653 32.3715)",
    style: {
      fill: "#141414"
    },
    cx: 46.9,
    cy: -13.1,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 44.3,
    cy: -9.5,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 41.7,
    cy: -6,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 39.1,
    cy: -2.5,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 13.9457 29.6896)",
    style: {
      fill: "#141414"
    },
    cx: 36.4,
    cy: 1,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 10.0658 29.0192)",
    style: {
      fill: "#141414"
    },
    cx: 33.8,
    cy: 4.5,
    rx: 0.9,
    ry: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M30.6,7.5c-0.3,0.4-0.2,0.9,0.2,1.2s0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2S30.8,7.2,30.6,7.5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M28,11.1c-0.3,0.3-0.2,0.8,0.2,1.1c0.3,0.3,0.8,0.2,1.1-0.2c0.3-0.3,0.2-0.8-0.2-1.1 C28.7,10.7,28.3,10.8,28,11.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M25.5,14.6c-0.2,0.3-0.2,0.8,0.1,1c0.3,0.2,0.8,0.2,1-0.1c0.2-0.3,0.2-0.8-0.1-1 C26.1,14.3,25.7,14.3,25.5,14.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M22.9,18.2c-0.2,0.3-0.2,0.7,0.1,0.9c0.3,0.2,0.7,0.2,0.9-0.1c0.2-0.3,0.2-0.7-0.1-0.9 C23.5,17.8,23.1,17.9,22.9,18.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M20.3,21.7c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C20.9,21.4,20.5,21.5,20.3,21.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M17.8,25.3c-0.2,0.3-0.1,0.6,0.1,0.8c0.3,0.2,0.6,0.1,0.8-0.1c0.2-0.3,0.1-0.6-0.1-0.8 C18.3,25,17.9,25,17.8,25.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5953 -0.8035 0.8035 0.5953 -17.0935 24.3259)",
    style: {
      fill: "#141414"
    },
    cx: 15.6,
    cy: 29.1,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M12.6,32.3c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C13.1,32.1,12.8,32.1,12.6,32.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M10,35.9c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C10.5,35.6,10.2,35.7,10,35.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: 7.8,
    cy: 39.7,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M4.8,42.9c-0.2,0.2-0.1,0.5,0.1,0.6c0.2,0.2,0.5,0.1,0.6-0.1c0.2-0.2,0.1-0.5-0.1-0.6 C5.3,42.7,5,42.7,4.8,42.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M2.2,46.4c-0.2,0.2-0.1,0.5,0.1,0.6c0.2,0.2,0.5,0.1,0.6-0.1s0.1-0.5-0.1-0.6 C2.6,46.2,2.4,46.2,2.2,46.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M-0.4,50c-0.2,0.2-0.1,0.5,0.1,0.6c0.2,0.2,0.5,0.1,0.6-0.1c0.2-0.2,0.1-0.5-0.1-0.6 C0,49.7-0.2,49.8-0.4,50z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#141414"
    },
    cx: -2.6,
    cy: 53.7,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M-5.6,57c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C-5.2,56.7-5.5,56.8-5.6,57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M-8.2,60.5c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1c0.2-0.2,0.1-0.5-0.1-0.7 C-7.8,60.2-8.1,60.3-8.2,60.5z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC552"
    },
    d: "M12.9,77.1c0,0,0.7,1.3,1.2,1.3s136.8,0,136.8,0s0.8-0.2,0.8-1.3H12.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M21.7,17.9v-2.3h0.4v2.3H21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M23.8,17.9l-0.5-0.9c-0.2-0.3-0.3-0.6-0.5-1h0c0,0.3,0,0.7,0,1v0.9h-0.4v-2.3H23l0.5,0.9 c0.2,0.3,0.3,0.6,0.5,1h0c0-0.3,0-0.7,0-1v-0.9h0.4v2.3H23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M25.5,15.6c0.8,0,1.2,0.4,1.2,1.1s-0.4,1.1-1.2,1.1h-0.7v-2.3H25.5z M25.2,17.5h0.3 c0.5,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-0.3V17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M27.4,15.9v0.6h1.1v0.3h-1.1v0.7h1.2v0.3H27v-2.3h1.5v0.3H27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M30.5,17.9h-0.4L29.5,17h0L29,17.9h-0.4l0.7-1.2l-0.7-1.1H29l0.5,0.8h0l0.5-0.8h0.4l-0.7,1.1 L30.5,17.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M122.4,72.8l-0.5-0.9c-0.2-0.3-0.3-0.6-0.5-1h0c0,0.3,0,0.7,0,1v0.9h-0.4v-2.3h0.5l0.5,0.9 c0.2,0.3,0.3,0.6,0.5,1h0c0-0.3,0-0.7,0-1v-0.9h0.4v2.3H122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M125.3,71.7c0,0.7-0.4,1.2-1,1.2c-0.6,0-1-0.5-1-1.2s0.4-1.2,1-1.2 C124.9,70.5,125.3,70.9,125.3,71.7z M123.6,71.7c0,0.5,0.3,0.8,0.7,0.8c0.4,0,0.7-0.3,0.7-0.8s-0.3-0.8-0.7-0.8 C123.9,70.8,123.6,71.1,123.6,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M125.6,72.8v-2.3h0.4v2.3H125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M127.9,71.2h-0.4c0-0.3-0.2-0.4-0.5-0.4c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.2,0.3,0.5,0.4 c0.4,0.1,0.8,0.2,0.8,0.7c0,0.4-0.3,0.7-0.8,0.7c-0.5,0-0.9-0.3-0.9-0.8h0.4c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.4-0.1,0.4-0.3 c0-0.2-0.2-0.3-0.5-0.4c-0.4-0.1-0.8-0.2-0.8-0.7c0-0.4,0.3-0.6,0.8-0.6C127.6,70.5,127.9,70.7,127.9,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M128.6,70.9v0.6h1.1v0.3h-1.1v0.7h1.2v0.3h-1.5v-2.3h1.5v0.3H128.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M131.5,70.5c0.6,0,0.8,0.2,0.8,0.6c0,0.3-0.2,0.5-0.4,0.6v0c0.2,0.1,0.2,0.1,0.3,0.4l0.2,0.6H132 l-0.2-0.6c-0.1-0.3-0.2-0.3-0.4-0.3h-0.3v0.9h-0.4v-2.3H131.5z M131.1,71.6h0.4c0.3,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.3-0.5-0.3h-0.4 V71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M133,70.9v0.6h1.1v0.3H133v0.7h1.2v0.3h-1.5v-2.3h1.5v0.3H133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M135.2,70.5c0.8,0,1.2,0.4,1.2,1.1s-0.4,1.1-1.2,1.1h-0.7v-2.3H135.2z M134.9,72.5h0.3 c0.5,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-0.3V72.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M138.4,71.9c0,0.6-0.3,0.9-0.9,0.9s-0.9-0.3-0.9-0.9v-1.4h0.4v1.4c0,0.4,0.2,0.6,0.5,0.6 s0.5-0.2,0.5-0.6v-1.4h0.4V71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M140.6,71.3h-0.4c0-0.3-0.2-0.5-0.5-0.5c-0.4,0-0.6,0.3-0.6,0.8s0.2,0.8,0.6,0.8 c0.3,0,0.5-0.2,0.5-0.5h0.4c0,0.5-0.4,0.8-0.9,0.8c-0.6,0-1-0.4-1-1.2s0.4-1.2,1-1.2C140.2,70.5,140.6,70.8,140.6,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M141.7,70.9v1.9h-0.4v-1.9h-0.7v-0.3h1.9v0.3H141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M142.6,72.8v-2.3h0.4v2.3H142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M145.3,71.7c0,0.7-0.4,1.2-1,1.2c-0.6,0-1-0.5-1-1.2s0.4-1.2,1-1.2 C144.9,70.5,145.3,70.9,145.3,71.7z M143.6,71.7c0,0.5,0.3,0.8,0.7,0.8c0.4,0,0.7-0.3,0.7-0.8s-0.3-0.8-0.7-0.8 C143.9,70.8,143.6,71.1,143.6,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M146.9,72.8l-0.5-0.9c-0.2-0.3-0.3-0.6-0.5-1h0c0,0.3,0,0.7,0,1v0.9h-0.4v-2.3h0.5l0.5,0.9 c0.2,0.3,0.3,0.6,0.5,1h0c0-0.3,0-0.7,0-1v-0.9h0.4v2.3H146.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M136.9,46.6v-2.3h0.4v2.3H136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M139,46.6l-0.5-0.9c-0.2-0.3-0.3-0.6-0.5-1h0c0,0.3,0,0.7,0,1v0.9h-0.4v-2.3h0.5l0.5,0.9 c0.2,0.3,0.3,0.6,0.5,1h0c0-0.3,0-0.7,0-1v-0.9h0.4v2.3H139z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M138.7,51.4c0,0.7-0.4,1.2-1,1.2c-0.6,0-1-0.5-1-1.2s0.4-1.2,1-1.2 C138.3,50.2,138.7,50.7,138.7,51.4z M137,51.4c0,0.5,0.3,0.8,0.7,0.8c0.4,0,0.7-0.3,0.7-0.8s-0.3-0.8-0.7-0.8 C137.3,50.6,137,50.9,137,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M140.7,51.7c0,0.6-0.3,0.9-0.9,0.9s-0.9-0.3-0.9-0.9v-1.4h0.4v1.4c0,0.4,0.2,0.6,0.5,0.6 s0.5-0.2,0.5-0.6v-1.4h0.4V51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M141.9,50.6v1.9h-0.4v-1.9h-0.7v-0.3h1.9v0.3H141.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M16.6,74v-1.5h-0.5v-0.3c0.3,0,0.5-0.1,0.5-0.4H17V74H16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M18.4,74v-1.5h-0.5v-0.3c0.3,0,0.5-0.1,0.5-0.4h0.3V74H18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M20.9,72.4c0,0.2-0.1,0.4-0.4,0.5v0c0.3,0.1,0.4,0.3,0.4,0.5c0,0.4-0.3,0.6-0.8,0.6 c-0.5,0-0.8-0.3-0.8-0.7h0.4c0,0.3,0.1,0.4,0.4,0.4c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.3-0.5-0.3H20v-0.3h0.1 c0.3,0,0.4-0.1,0.4-0.3c0-0.2-0.1-0.3-0.4-0.3c-0.2,0-0.4,0.1-0.4,0.4h-0.4c0-0.4,0.3-0.7,0.8-0.7C20.6,71.8,20.9,72.1,20.9,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M23.1,72.4h-0.4c0-0.3-0.2-0.4-0.5-0.4c-0.4,0-0.7,0.3-0.7,0.8c0,0.5,0.2,0.9,0.6,0.9 c0.3,0,0.6-0.2,0.6-0.6h-0.6v-0.3h0.9V74h-0.3v-0.3h0c-0.1,0.2-0.4,0.3-0.7,0.3c-0.6,0-0.9-0.4-0.9-1.2c0-0.7,0.4-1.2,1-1.2 C22.7,71.7,23,72,23.1,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M24.3,71.8c0.5,0,0.8,0.3,0.8,0.7c0,0.4-0.3,0.7-0.8,0.7h-0.4V74h-0.4v-2.3H24.3z M23.8,72.8h0.4 c0.3,0,0.5-0.1,0.5-0.4c0-0.2-0.1-0.4-0.5-0.4h-0.4V72.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.7,42.5V41h-0.5v-0.3c0.3,0,0.5-0.1,0.5-0.4h0.3v2.1H65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5,41.4c0,0.7-0.3,1.1-0.8,1.1c-0.5,0-0.8-0.4-0.8-1.1c0-0.7,0.3-1.1,0.8-1.1C68.2,40.3,68.5,40.7,68.5,41.4z  M67.2,41.4c0,0.5,0.1,0.8,0.4,0.8c0.3,0,0.4-0.3,0.4-0.8c0-0.5-0.1-0.8-0.4-0.8C67.4,40.6,67.2,40.9,67.2,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3,41.4c0,0.7-0.3,1.1-0.8,1.1c-0.5,0-0.8-0.4-0.8-1.1c0-0.7,0.3-1.1,0.8-1.1C70,40.3,70.3,40.7,70.3,41.4z M69.1,41.4 c0,0.5,0.1,0.8,0.4,0.8c0.3,0,0.4-0.3,0.4-0.8c0-0.5-0.1-0.8-0.4-0.8C69.2,40.6,69.1,40.9,69.1,41.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82,40.6l-0.1,0.6h0c0.1-0.1,0.3-0.2,0.4-0.2c0.4,0,0.7,0.3,0.7,0.7c0,0.5-0.3,0.8-0.8,0.8c-0.4,0-0.7-0.2-0.7-0.6h0.4 c0,0.2,0.2,0.3,0.4,0.3c0.3,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4c-0.2,0-0.3,0.1-0.4,0.3l-0.4,0l0.1-1.3h1.3v0.3H82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9,41.4c0,0.7-0.3,1.1-0.8,1.1c-0.5,0-0.8-0.4-0.8-1.1c0-0.7,0.3-1.1,0.8-1.1C84.6,40.3,84.9,40.7,84.9,41.4z  M83.7,41.4c0,0.5,0.1,0.8,0.4,0.8c0.3,0,0.4-0.3,0.4-0.8c0-0.5-0.1-0.8-0.4-0.8C83.8,40.6,83.7,40.9,83.7,41.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.9,41.4c0,0.7-0.3,1.1-0.8,1.1c-0.5,0-0.8-0.4-0.8-1.1c0-0.7,0.3-1.1,0.8-1.1C99.6,40.3,99.9,40.7,99.9,41.4z  M98.7,41.4c0,0.5,0.1,0.8,0.4,0.8c0.3,0,0.4-0.3,0.4-0.8c0-0.5-0.1-0.8-0.4-0.8C98.8,40.6,98.7,40.9,98.7,41.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.4,
    y: -43.5,
    transform: "matrix(7.486660e-03 -1 1 7.486660e-03 58.0025 104.4355)",
    style: {
      fill: "#141414"
    },
    width: 0.5,
    height: 133
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.4,
    y: -35.6,
    transform: "matrix(7.490330e-03 -1 1 7.490330e-03 50.0901 112.2885)",
    style: {
      fill: "#141414"
    },
    width: 0.5,
    height: 133
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "158.8,68.4 159.7,69.8 159.3,93.1 158.5,94.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M117.6,62.4H48.3c-5.7,0-10.4-4.6-10.4-10.4v-3.5c0-5.7,4.6-10.4,10.4-10.4h69.3 c5.7,0,10.4,4.6,10.4,10.4v3.5C128,57.8,123.3,62.4,117.6,62.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF9EE"
    },
    d: "M124.9,49.8c0,2.8-1.2,5.4-3.2,7.1c-1.7,1.5-3.9,2.4-6.4,2.4c-0.1,0-0.3,0-0.4,0H50l-1.5-0.2l0,0 c-4.4-0.9-7.6-4.8-7.6-9.4c0-5.3,4.3-9.6,9.6-9.6h64.9C120.6,40.2,124.9,44.5,124.9,49.8z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.4,60.4c-0.2,0-0.3,0-0.5,0c-0.6,0-1.1-0.1-1.7-0.2c-4.9-1-8.4-5.4-8.4-10.4c0-5.8,4.7-10.6,10.6-10.6 c5.8,0,10.6,4.7,10.6,10.6c0,0.2,0,0.3,0,0.5c-0.2,5.4-4.7,9.9-10.1,10.1C50.7,60.4,50.6,60.4,50.4,60.4z M50.4,41.2 c-4.7,0-8.6,3.8-8.6,8.6c0,4.1,2.9,7.6,6.8,8.4c0.4,0.1,0.9,0.1,1.4,0.2c0.2,0,0.5,0,0.7,0c4.4-0.2,8-3.8,8.2-8.2 c0-0.1,0-0.3,0-0.4C59,45.1,55.2,41.2,50.4,41.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M60,50.2c-0.2,5-4.2,8.9-9.1,9.2c-2-0.1-3.8-0.8-5.2-2c-1.9-1.6-3.2-4-3.2-6.7 c0-4.8,3.9-8.8,8.8-8.8c2.7,0,5.1,1.2,6.7,3.2C59.2,46.4,59.9,48.2,60,50.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF9EE"
    },
    d: "M60,50.2c0,0.5-0.1,0.9-0.2,1.4c-0.2,0.9-0.4,1.7-0.8,2.4c-0.7,1.4-1.7,2.6-3,3.6 c-0.7,0.5-1.5,0.9-2.3,1.2c-0.9,0.3-1.9,0.5-2.9,0.6c-1.4-0.1-2.8-0.5-4-1.2c-0.4-0.3-0.9-0.5-1.3-0.9c-0.2-0.3-0.5-0.6-0.7-0.9 c-0.9-1.4-1.4-3-1.4-4.7c0-4.8,3.9-8.8,8.8-8.8c2,0,3.9,0.7,5.3,1.8c0.1,0.1,0.2,0.1,0.3,0.2c0.5,0.6,0.9,1.2,1.2,1.9 C59.7,47.9,60,49,60,50.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M56,57.5c-0.7,0.5-1.5,0.9-2.3,1.2l-0.9-1.3L55,56L56,57.5z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.3,60.4c-0.2,0-0.3,0-0.4,0c-3-0.1-5.9-1.6-7.8-4c-1.5-1.9-2.3-4.2-2.3-6.6c0-5.8,4.7-10.6,10.6-10.6 c5.8,0,10.6,4.7,10.6,10.6c0,3-1.3,5.9-3.5,7.9C120.4,59.4,117.9,60.4,115.3,60.4z M115.3,41.2c-4.7,0-8.6,3.8-8.6,8.6 c0,2,0.6,3.8,1.9,5.4c1.6,1.9,3.9,3.1,6.3,3.2c0.1,0,0.2,0,0.4,0c2.1,0,4.1-0.8,5.7-2.2c1.8-1.6,2.9-4,2.9-6.4 C123.9,45.1,120.1,41.2,115.3,41.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M124,51c0,0.6-0.1,1.1-0.2,1.7c-0.2,0.8-0.4,1.6-0.8,2.3c-0.4,0.7-0.8,1.4-1.3,1.9 c-0.1,0.1-0.2,0.2-0.3,0.3l0,0c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.3,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1 c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.2,0.1 c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0-0.2,0.1-0.2,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.4,0.1 c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.2,0-0.3,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0 c0,0,0,0,0,0c-0.1,0-0.2,0-0.4,0c0,0,0,0-0.1,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.3,0-0.5,0-0.8-0.1 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5-0.1-0.7-0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3-0.1-0.4-0.1 c-0.1,0-0.1,0-0.2-0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.2-0.1 c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1,0-0.1-0.1-0.2-0.1 c0,0,0,0,0,0c-0.2-0.1-0.4-0.3-0.5-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.3 c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.3-0.4-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.3 c0-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.1-0.3c0,0,0,0,0,0c0-0.1-0.1-0.2-0.1-0.3c0,0,0,0,0-0.1 c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.3-0.1-0.5-0.2-0.8c0-0.2-0.1-0.4-0.1-0.5c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.4c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3c0,0,0,0,0,0v0c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0.1-0.3c1-3.8,4.4-6.6,8.5-6.6c4.5,0,8.3,3.4,8.7,7.9 C124,50.4,124,50.7,124,51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF9EE"
    },
    d: "M123.3,52.7L123.3,52.7c0,0.8-0.1,1.6-0.3,2.2c-0.4,0.7-0.8,1.4-1.3,1.9c-0.3,0.3-0.6,0.5-0.9,0.7 c-0.7,0.5-1.5,0.9-2.3,1.2c-1,0.3-2.1,0.5-3.2,0.5c-1.2,0-2.3-0.2-3.4-0.6c-0.8-0.3-1.6-0.7-2.3-1.2c-0.7-0.5-1.3-1.1-1.8-1.7 c-0.6-0.9-1-1.9-1.2-3c-0.1-0.6-0.2-1.2-0.2-1.8c0-0.3,0-0.5,0-0.8c0-0.5,0.1-0.9,0.2-1.4c0.7-1.4,1.8-2.6,3.2-3.5 c0.7-0.5,1.5-0.8,2.4-1c0.7-0.2,1.5-0.3,2.2-0.3c1.3,0,2.6,0.3,3.8,0.8c0.8,0.4,1.5,0.9,2.1,1.4c1.1,1,2,2.4,2.5,3.9 C123.2,51,123.3,51.8,123.3,52.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.9,
    y: 40.2,
    style: {
      fill: "#FCF9EE"
    },
    width: 40.5,
    height: 16.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 47.4,
    style: {
      fill: "#141414"
    },
    width: 37.4,
    height: 7.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M67.4,45.7c-0.1,0-0.2-0.1-0.2-0.2v-2.5c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v2.5 C67.7,45.6,67.6,45.7,67.4,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M70.7,45.7c-0.1,0-0.2-0.1-0.2-0.2v-2.1c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v2.1 C70.9,45.6,70.8,45.7,70.7,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M69,45.7c-0.1,0-0.2-0.1-0.2-0.2v-1.2c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v1.2 C69.3,45.6,69.2,45.7,69,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M72.2,45.7c-0.1,0-0.2-0.1-0.2-0.2v-1.2c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v1.2 C72.5,45.6,72.4,45.7,72.2,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M75.4,45.7c-0.1,0-0.2-0.1-0.2-0.2v-1.2c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v1.2 C75.6,45.6,75.5,45.7,75.4,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M78.5,45.7c-0.1,0-0.2-0.1-0.2-0.2v-1.2c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v1.2 C78.8,45.6,78.7,45.7,78.5,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M81.7,45.7c-0.1,0-0.2-0.1-0.2-0.2v-1.2c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v1.2 C81.9,45.6,81.8,45.7,81.7,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M84.8,45.7c-0.1,0-0.2-0.1-0.2-0.2v-1.2c0-0.1,0.1-0.2,0.2-0.2S85,44,85,44.2v1.2 C85,45.6,84.9,45.7,84.8,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M87.9,45.7c-0.1,0-0.2-0.1-0.2-0.2v-1.2c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v1.2 C88.1,45.6,88,45.7,87.9,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M91.1,45.7c-0.1,0-0.2-0.1-0.2-0.2v-1.2c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v1.2 C91.3,45.6,91.2,45.7,91.1,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M94.1,45.7c-0.1,0-0.2-0.1-0.2-0.2v-1.2c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v1.2 C94.3,45.6,94.2,45.7,94.1,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M97.4,45.7c-0.1,0-0.2-0.1-0.2-0.2v-1.2c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v1.2 C97.7,45.6,97.6,45.7,97.4,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M73.8,45.7c-0.1,0-0.2-0.1-0.2-0.2v-2.1c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v2.1 C74,45.6,73.9,45.7,73.8,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M76.9,45.7c-0.1,0-0.2-0.1-0.2-0.2v-2.1c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v2.1 C77.2,45.6,77.1,45.7,76.9,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M80.1,45.7c-0.1,0-0.2-0.1-0.2-0.2v-2.1c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v2.1 C80.4,45.6,80.3,45.7,80.1,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M86.4,45.7c-0.1,0-0.2-0.1-0.2-0.2v-2.1c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v2.1 C86.6,45.6,86.5,45.7,86.4,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M89.4,45.7c-0.1,0-0.2-0.1-0.2-0.2v-2.1c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v2.1 C89.6,45.6,89.5,45.7,89.4,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M92.7,45.7c-0.1,0-0.2-0.1-0.2-0.2v-2.1c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v2.1 C93,45.6,92.9,45.7,92.7,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M95.8,45.7c-0.1,0-0.2-0.1-0.2-0.2v-2.1c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v2.1 C96,45.6,95.9,45.7,95.8,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M83.2,45.7c-0.1,0-0.2-0.1-0.2-0.2v-2.5c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v2.5 C83.4,45.6,83.3,45.7,83.2,45.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171B1E"
    },
    d: "M99.1,45.7c-0.1,0-0.2-0.1-0.2-0.2v-2.5c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2v2.5 C99.3,45.6,99.2,45.7,99.1,45.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M53.9,19.7c0,0.1,0,0.3,0,0.5c0,0.3,0,0.5,0,0.5c0,0.4-0.1,0.7-0.2,1.2c0,0.1,0,0.1-0.1,0.2 c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2l-0.1,0.3c-0.1,0.2-0.1,0.4-0.1,0.4c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.2-0.2,0.3-0.2,0.4 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.2-0.2,0.3-0.3,0.5c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0.1c0,0.1-0.1,0.1-0.1,0.1 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.3-0.3,0.4c-0.2,0.3-0.4,0.5-0.5,0.6c0,0-0.2,0.1-0.4,0.4c-0.1,0-0.1,0.1-0.2,0.2 c-0.4,0.4-0.6,0.6-0.7,0.7c-0.1,0.1-0.3,0.3-0.6,0.4c0,0-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.1-0.2,0.1c0,0-0.1,0.1-0.2,0.1 c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.2,0.1c-0.2,0.1-0.4,0.2-0.6,0.3c0,0-0.1,0-0.2,0c0,0,0,0,0,0 c0,0,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0h0c0,0-0.1,0-0.2,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0 c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.2,0c-0.1,0-0.2,0.1-0.3,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0 c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.1,0-0.2,0-0.3c0-0.3,0-0.4,0-0.6c0-0.1,0-0.3,0.1-0.5c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.2,0-0.2 c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0.1-0.2l0.1-0.3c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2 s0-0.1,0.1-0.2c0,0,0-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0,0,0-0.1,0.1-0.3c0.1-0.4,0.2-0.5,0.2-0.6c0-0.1,0-0.1,0.1-0.2 s0-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0,0,0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2c0,0,0.1-0.2,0.2-0.4 c0.1-0.3,0.2-0.4,0.2-0.6c0,0,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2s0.1-0.2,0.1-0.2c0,0,0.1-0.1,0.1-0.2 c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0.1-0.2,0.1-0.4v-0.1c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1 c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.2,0.3l-0.1,0.1c0-0.1,0-0.1,0-0.1c0,0-0.1,0.1-0.1,0.1 c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0-0.1,0-0.1,0-0.1c0,0-0.1,0-0.1,0l0,0c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0,0-0.1,0.1 c0,0-0.1,0.1-0.1,0.1l0,0l0-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0,0-0.1c0,0-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0 c0,0,0,0,0,0l0-0.1c0,0,0,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1l0-0.1c0-0.1,0-0.1,0-0.1c-0.1,0.1-0.2,0.1-0.3,0.2 c0-0.1,0.1-0.3,0.2-0.5c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.2-0.2,0.3-0.3,0.4c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3 c0.1-0.1,0.1-0.2,0.1-0.2l-0.1,0.1c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.2,0.3c0,0,0,0-0.1,0c0-0.1,0-0.2,0.1-0.3 c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.1-0.2c-0.1,0.1-0.1,0.2-0.2,0.4s-0.2,0.3-0.2,0.4h0c0,0,0,0,0-0.1v-0.1c0,0-0.1,0-0.1,0 c0.1-0.2,0.1-0.3,0.1-0.4c0,0,0-0.1,0-0.2c0-0.1,0.1-0.3,0.3-0.6c0,0,0-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.1-0.2 c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.2-0.1,0.5-0.3,0.7-0.3c0.3-0.1,0.7-0.2,1.1-0.2c0.1,0,0.3,0,0.6,0 c0.1,0,0.4,0,0.7,0c0.1,0,0.2,0,0.2,0s0.1,0,0.1,0.1c0,0,0.1,0,0.1,0c1,0.2,1.8,0.7,2.4,1.3C53.5,18.5,53.8,19,53.9,19.7L53.9,19.7 z M47.2,27.4l0,0.1C47.2,27.5,47.2,27.5,47.2,27.4C47.2,27.5,47.2,27.5,47.2,27.4c0.1,0,0.1,0,0.2-0.1s0.2-0.1,0.2-0.2 c0,0,0.1-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.2,0.4-0.3c0.3-0.3,0.5-0.4,0.5-0.5c0.1-0.1,0.2-0.2,0.4-0.4 c0.3-0.3,0.5-0.6,0.6-0.7c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.3,0.4-0.7c0-0.1,0.1-0.2,0.2-0.4 c0.1-0.2,0.1-0.3,0.1-0.3c0-0.1,0.1-0.2,0.2-0.5c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1,0.1-0.2,0.1-0.4C52,21,52,20.9,52,20.9 c0,0,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.3,0-0.5c0-0.3-0.1-0.5-0.2-0.8c-0.1-0.2-0.2-0.4-0.3-0.5c0,0-0.1-0.1-0.1-0.1 c-0.1,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.3-0.2-0.6-0.3c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1,0-0.1,0.1C49.7,19.4,48.7,22.5,47.2,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M59.5,22.4C59.5,22.4,59.5,22.5,59.5,22.4c0,0.1,0,0.1,0,0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0 c0,0,0,0,0,0.1c0,0,0,0,0,0c-0.2,0-0.4,0.1-0.5,0.1l0,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0.1,0,0.3,0c0,0,0,0,0.1,0v0 c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.2,0.1l-0.1,0h0c0,0,0,0,0.1,0l0,0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0 c-0.2,0.1-0.3,0.1-0.5,0.2c0,0,0,0,0,0.1L57.4,24c0,0-0.1,0-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0.1-0.3,0.1-0.5,0.1c0,0,0,0,0,0 c0,0-0.1,0-0.2,0.1s-0.1,0-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1s-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0-0.1,0.1 c0,0.1-0.2,0.3-0.3,0.8v0c0,0.1,0,0.1-0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1 c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1v0c0,0.1,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.5,0c0.3,0,0.9-0.2,1.7-0.5 c0.2-0.1,0.4-0.1,0.5-0.2c0,0,0,0,0,0c0.2-0.1,0.4-0.1,0.6-0.2c0,0,0,0,0,0c0,0,0,0,0,0c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1 c0,0,0,0.1-0.1,0.1c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0.1,0.1,0,0.2-0.1,0.3 c0,0.1,0,0.1-0.1,0.1c0,0,0,0,0,0s0,0,0,0h0c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0 c0,0.1-0.1,0.2-0.1,0.2c0,0-0.1,0.1-0.2,0.1c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.3,0.2-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0,0,0 c0,0,0,0-0.1,0.1c-0.1,0-0.1,0-0.2,0.1c0,0,0,0-0.1,0s0,0-0.1,0c-0.1,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0c-0.5,0.1-0.9,0.3-1.4,0.4 c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4,0c-0.2,0-0.4-0.1-0.6-0.2 c-0.2-0.1-0.3-0.3-0.3-0.5c0,0,0-0.1,0-0.1h0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0.1-0.2,0.1-0.3,0.1-0.5c0,0,0,0,0-0.1c0,0,0,0,0-0.1 c0-0.1,0.1-0.3,0.1-0.4c0.1-0.4,0.3-0.8,0.4-1.2c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c-0.2,0.1-0.4,0.1-0.7,0.2c0,0,0-0.1,0.1-0.2 c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0.1-0.1,0.2-0.1 s0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0,0,0,0,0.1-0.1l0,0c0.2-0.2,0.5-0.3,0.9-0.4c0.2-0.1,0.4-0.1,0.7-0.2c0,0,0.1,0,0.2-0.1 s0.1,0,0.2-0.1c0.5-0.2,1-0.3,1.3-0.3c0.3-0.1,0.5-0.1,0.8-0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.2-0.1,0.5-0.1,0.7-0.1 c0,0,0,0,0.1,0c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0C59.2,22.5,59.3,22.5,59.5,22.4z M60.8,20.4C60.8,20.4,60.8,20.4,60.8,20.4 c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0h0c-0.2,0-0.5,0.1-0.7,0.1v0c0.1,0,0.3,0,0.7,0c0,0,0,0,0.1,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.2,0 c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.3,0-0.4,0.1c0,0,0,0,0,0c-0.1,0.1-0.2,0.1-0.3,0.1c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0h0 c-0.5,0.1-0.9,0.2-1.1,0.2c-0.6,0.1-1.4,0.3-2.2,0.7c-0.1,0-0.2,0.1-0.4,0.2c-0.2,0.1-0.3,0.1-0.4,0.1c-0.2,0.1-0.5,0.2-0.7,0.3 c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1,0.1-0.2,0-0.3-0.1c-0.1-0.1,0-0.2,0-0.3c0.1-0.2,0.3-0.3,0.3-0.4c0,0,0-0.1,0.1-0.2c0,0,0,0,0-0.1 c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.2,0.1-0.2c0,0,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3 c0.1,0,0.2-0.1,0.4-0.2s0.3-0.2,0.4-0.2c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.2-0.1,0.3-0.1c0,0,0,0,0,0s0,0,0,0 c0.3-0.1,0.5-0.1,0.5-0.1c0.6-0.2,1.3-0.3,1.9-0.3c0.1,0,0.2,0,0.4,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1 c0,0,0,0.1-0.1,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.3,0,0.4,0c0,0,0,0,0.1,0.1c0,0,0,0.1,0,0.1c-0.1,0-0.3,0.1-0.4,0.1 c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0C60.5,20.3,60.7,20.3,60.8,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M66.1,19.9c0.1,0.2,0.1,0.5,0.1,0.7c-0.1,0.3-0.2,0.5-0.4,0.7c-0.3,0.3-0.7,0.7-1.1,1 c-0.5,0.4-1,0.7-1.5,0.9c-0.2,0.1-0.6,0.3-1.1,0.5c-0.2,0.1-0.3,0.1-0.5,0.2c0,0,0,0-0.1,0c-0.2,0-0.3,0.1-0.3,0.3 c-0.1,0.5-0.3,1.2-0.6,2.1c-0.1,0.3-0.2,0.5-0.2,0.6c0,0.1-0.1,0.4-0.2,0.8c0,0.1-0.1,0.3-0.2,0.6c0,0,0,0.1,0,0.2l0,0.1h0 c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0.1-0.1,0.1-0.2,0.1c0,0,0,0,0,0h0c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1c0,0,0,0-0.1,0 c0,0,0,0,0,0c-0.1,0.1-0.2,0.1-0.3,0.1l0,0l0-0.1l-0.1,0.1v-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0.1-0.9,0.3-1.7,0.5-2.3 c0-0.2,0.1-0.4,0.2-0.8c0.1-0.6,0.2-1,0.3-1.3c0.1-0.2,0.2-0.6,0.3-1l0,0c0.1-0.3,0.2-0.7,0.4-1.2c0.1-0.2,0.1-0.4,0.2-0.6 c0,0,0-0.1,0-0.1l0,0h0c-0.1,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2-0.1c0,0-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c0,0,0-0.1,0-0.1h0 c0-0.1,0-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.2c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c-0.1-0.1,0-0.2,0-0.2c0.1-0.1,0.1-0.1,0.2-0.1 c0.2-0.1,0.4-0.2,0.6-0.3c0.6-0.2,1.3-0.5,2.3-0.7c0.8-0.2,1.5-0.2,2.1-0.1c0.1,0,0.2,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2 c0,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.2c0,0,0,0.1,0.1,0.1C65.9,19.7,66,19.9,66.1,19.9z M64.5,20.6 c0.3-0.2,0.5-0.4,0.6-0.7c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.3,0-0.7,0-1,0.1c-0.2,0-0.4,0.1-0.8,0.2c-0.2,0-0.4,0.1-0.5,0.1 c-0.1,0-0.1,0.1-0.1,0.1c-0.1,0.2-0.2,0.5-0.3,0.9c-0.1,0.3-0.2,0.5-0.2,0.6c0,0.1-0.1,0.2-0.1,0.3c0,0,0,0,0,0.1l0.4-0.2 C63.1,21.6,63.8,21.1,64.5,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M68.9,26.5c0.1,0,0.2,0,0.4,0c0.2,0,0.2,0,0.3,0c0,0.1-0.1,0.3-0.4,0.7c-0.2,0.4-0.4,0.7-0.4,0.8 c-0.1,0-0.2,0-0.2,0c-0.3,0-0.8,0.1-1.3,0.1c-0.6,0.1-1.1,0.2-1.5,0.4c-0.1,0-0.3,0.1-0.5,0.2c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0 l0,0h0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0s0,0,0-0.1s0,0,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0 c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0.1-0.1,0.2-0.2,0.2-0.2c0,0,0,0,0-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1-0.1 c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0h0l0,0c0-0.1,0.2-0.3,0.4-0.5c0,0,0,0,0,0c0,0,0,0-0.1-0.1 s0,0,0-0.1c0.1,0,0.1-0.1,0.2-0.1h0C64.9,27,65,27,65.1,27c0.1,0,0.2-0.1,0.3-0.3c0.3-0.7,0.5-1.4,0.8-2.3c0.1-0.4,0.3-0.9,0.4-1.5 c0-0.1,0.1-0.3,0.1-0.5c0.1-0.5,0.2-0.8,0.3-1c0.1-0.2,0.1-0.5,0.3-0.9c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1h0 c0,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0l0,0l0,0c0,0,0,0,0.1,0c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.3,0l0,0l0,0l0,0l0,0c0,0,0,0,0,0 c0.1,0,0.2-0.1,0.3,0c0,0,0.1,0,0.1,0l0,0l0,0v0c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.4-0.2,0.6-0.2,0.8c-0.1,0.2-0.2,0.6-0.3,1.1 c-0.1,0.3-0.1,0.6-0.2,0.7c-0.1,0.5-0.2,1-0.3,1.2c-0.2,0.6-0.3,1-0.4,1.4c0,0.1-0.1,0.3-0.2,0.6c-0.1,0.1-0.1,0.2-0.1,0.3 c0,0,0,0.1,0,0.1l0,0h0c0.1,0,0.1,0,0.1,0c0.3,0,0.8-0.1,1.4-0.1C68.7,26.5,68.8,26.5,68.9,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M75,19.4L75,19.4L75,19.4C75.1,19.5,75.1,19.5,75,19.4c0,0.1,0,0.2,0,0.2c-0.1,0.5-0.2,1.1-0.4,1.8 c-0.1,0.5-0.3,1.1-0.5,1.7c-0.1,0.3-0.2,0.7-0.4,1.3c-0.1,0.4-0.2,0.7-0.2,0.8l-0.1,0.4c-0.2,0.6-0.3,1-0.4,1.3 c-0.1,0.3-0.2,0.7-0.3,1.2c0,0.2-0.1,0.3-0.1,0.4c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0l0,0l-0.1-0.1 l-0.3,0.2l-0.1,0c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.1,0.1l0,0l-0.1-0.1l-0.2,0.2l0,0l-0.2,0.2l0,0c0,0-0.1,0-0.1,0 c0,0-0.1,0-0.1,0h0l0,0l0-0.2c0-0.2,0-0.3,0-0.4c0-0.4,0-0.7,0-1c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4-0.1-0.5c-0.1-0.5-0.3-0.9-0.6-1.3 c0,0,0,0,0,0c-0.5,0.8-0.8,1.4-1.1,2l0,0h0c-0.1,0-0.2,0-0.3,0.1l0,0l-0.1,0l-0.3,0.2l0,0l-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0h0v-0.1l0,0l0,0c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.2,0-0.3 c0.2-0.2,0.3-0.5,0.6-0.8c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.6,0.5-0.8c0,0-0.1-0.1-0.2-0.1l0,0c-0.1,0-0.2-0.1-0.3-0.2 c-0.1,0-0.1,0-0.1-0.1l-0.2-0.1l0-0.1l0.2,0l-0.1-0.1l0.2-0.1c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1 c0,0,0.1-0.1,0.2-0.1c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.2,0h0c0.2-0.4,0.4-0.6,0.4-0.7c0.1-0.2,0.3-0.4,0.5-0.7l0.8-1.1 c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.3,0.4-0.4,0.6-0.5c0,0,0,0,0,0c0,0,0.1,0,0.1,0 c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0.1,0s0,0,0.1,0h0h0c0,0,0,0,0,0s0,0,0,0 c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.2,0C75,19.4,75,19.4,75,19.4z  M72.1,25.3c0.2-0.7,0.5-1.7,0.8-2.8l-1.6,2c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3 c0,0,0.1,0.1,0.1,0.1C72.1,25.2,72.1,25.2,72.1,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M79.9,20L79.9,20c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c-0.3,0.7-0.4,1-0.4,1.1 c-0.1,0.1-0.1,0.2-0.2,0.2c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0.1 c-0.1,0.1-0.3,0.1-0.5,0.1c0,0-0.1,0-0.2,0.1c0,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0,0,0-0.1c0-0.1,0.1-0.2,0.2-0.4 s0.1-0.2,0.2-0.3c0,0,0,0,0-0.1L78,21c-0.7,0.7-1.2,1.4-1.5,2c-0.5,0.9-0.9,1.8-1.1,2.7c-0.1,0.5-0.2,1-0.2,1.3c0,0,0,0.3,0,0.8 c0,0,0,0,0,0l0.2-0.2c0.6-0.6,1.1-1.2,1.5-1.7c0.3-0.3,0.4-0.6,0.5-0.7l0-0.1l0.1,0.2c0.1,0,0.1,0,0.2-0.1c0,0,0,0,0,0.1 c0,0,0,0,0,0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0s0,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0.1,0,0.1,0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0.1 c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0.1,0,0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0s0,0,0.1,0 c0,0,0,0,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l-0.1,0.2c-0.3,0.4-0.8,1-1.5,1.9c-0.3,0.3-0.6,0.6-0.8,0.7 c-0.3,0.2-0.5,0.3-0.8,0.2c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.3-0.1-0.5-0.2c-0.3-0.1-0.5-0.2-0.6-0.3c-0.2-0.1-0.4-0.3-0.6-0.6 c-0.1-0.1-0.1-0.4-0.2-0.7c0,0,0-0.2,0-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2v0c0.1-0.4,0.1-0.6,0.1-0.6 c0.2-1.1,0.7-2.3,1.5-3.4c0.5-0.7,1-1.3,1.8-1.7c0.3-0.1,0.7-0.3,1.2-0.5c0.2-0.1,0.4-0.1,0.6,0c0.1,0,0.2,0,0.3,0 c0.1,0,0.1,0,0.1,0c0.3,0.1,0.4,0.1,0.4,0.1C79.8,19.8,79.9,19.9,79.9,20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M85.4,22.4C85.5,22.4,85.5,22.5,85.4,22.4c0,0.1,0,0.1,0,0.1c0,0,0,0-0.1,0s-0.1,0-0.1,0 c0,0,0,0,0,0.1c0,0,0,0,0,0c-0.2,0-0.4,0.1-0.5,0.1l0,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0.1,0,0.3,0c0,0,0,0,0.1,0v0 c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.2,0.1l-0.1,0h0c0,0,0,0,0.1,0l0,0.1c0,0,0,0-0.1,0s-0.1,0-0.1,0 c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0s-0.1,0-0.1,0c0,0,0,0,0,0c-0.2,0.1-0.3,0.1-0.5,0.2 c0,0,0,0,0,0.1L83.4,24c0,0-0.1,0-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0.1-0.3,0.1-0.5,0.1c0,0,0,0,0,0c0,0-0.1,0-0.2,0.1 s-0.1,0-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1s-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0-0.1,0.1c0,0.1-0.2,0.3-0.3,0.8v0 c0,0.1,0,0.1-0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1v0 c0,0.1,0,0.1,0.1,0.1c0.1,0.1,0.3,0.1,0.5,0c0.3,0,0.9-0.2,1.7-0.5c0.2-0.1,0.4-0.1,0.5-0.2c0,0,0,0,0,0c0.2-0.1,0.4-0.1,0.6-0.2 c0,0,0,0,0,0c0,0,0,0,0,0c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.2-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1 c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0.1,0.1,0,0.2-0.1,0.3c0,0.1,0,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0h0c-0.1,0-0.1,0.1-0.2,0.1 c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0.1-0.1,0.2-0.1,0.2c0,0-0.1,0.1-0.2,0.1c0,0,0,0.1-0.1,0.1 c-0.1,0.1-0.3,0.2-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0.1c-0.1,0-0.1,0-0.2,0.1c0,0,0,0-0.1,0s0,0-0.1,0 c-0.1,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0c-0.5,0.1-0.9,0.3-1.4,0.4c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0.1-0.3,0.1-0.4,0.1 c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4,0c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.3-0.3-0.3-0.5c0,0,0-0.1,0-0.1h0c0,0,0,0,0-0.1 c0,0,0-0.1,0-0.1c0.1-0.2,0.1-0.3,0.1-0.5c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0-0.1,0.1-0.3,0.1-0.4c0.1-0.4,0.3-0.8,0.4-1.2 c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c-0.2,0.1-0.4,0.1-0.7,0.2c0,0,0-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.1,0.2-0.1 c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0.1-0.1,0.2-0.1s0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.2-0.3 c0,0,0,0,0.1-0.1l0,0c0.2-0.2,0.5-0.3,0.9-0.4c0.2-0.1,0.4-0.1,0.7-0.2c0,0,0.1,0,0.2-0.1s0.1,0,0.2-0.1c0.5-0.2,1-0.3,1.3-0.3 c0.3-0.1,0.5-0.1,0.8-0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.2-0.1,0.5-0.1,0.7-0.1c0,0,0,0,0.1,0c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0 C85.1,22.5,85.3,22.5,85.4,22.4z M86.7,20.4C86.8,20.4,86.8,20.4,86.7,20.4c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0h0 c-0.2,0-0.5,0.1-0.7,0.1v0c0.1,0,0.3,0,0.7,0c0,0,0,0,0.1,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.2,0c0,0.1,0,0.1-0.1,0.1 c-0.1,0-0.3,0-0.4,0.1c0,0,0,0,0,0c-0.1,0.1-0.2,0.1-0.3,0.1c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0h0c-0.5,0.1-0.9,0.2-1.1,0.2 c-0.6,0.1-1.4,0.3-2.2,0.7c-0.1,0-0.2,0.1-0.4,0.2c-0.2,0.1-0.3,0.1-0.4,0.1c-0.2,0.1-0.5,0.2-0.7,0.3c-0.1,0.1-0.2,0.1-0.4,0.2 c-0.1,0.1-0.2,0-0.3-0.1c-0.1-0.1,0-0.2,0-0.3c0.1-0.2,0.3-0.3,0.3-0.4c0,0,0-0.1,0.1-0.2c0,0,0,0,0-0.1c0,0,0,0,0-0.1 c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.2,0.1-0.2c0,0,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.2-0.1,0.4-0.2 s0.3-0.2,0.4-0.2c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.2-0.1,0.3-0.1c0,0,0,0,0,0s0,0,0,0c0.3-0.1,0.5-0.1,0.5-0.1 c0.6-0.2,1.3-0.3,1.9-0.3c0.1,0,0.2,0,0.4,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0.1,0,0.1,0 c0,0,0,0,0,0c0.1,0,0.3,0,0.4,0c0,0,0,0,0.1,0.1c0,0,0,0.1,0,0.1c-0.1,0-0.3,0.1-0.4,0.1c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0 C86.4,20.3,86.6,20.3,86.7,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M94.4,17.3L94.4,17.3l0.1,0c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.1,0.1c0,0.8,0,1.2,0,1.3 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3l0,0.5c0,0.1,0,0.1,0,0.2s0,0.2,0,0.3 s0,0.2,0,0.2c0,0.4,0,0.7,0,0.7c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.4,0,1c0,0,0,0.1,0,0.3c0-0.1,0.1-0.1,0.1-0.2 c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2s0-0.1,0.1-0.2c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.1,0.2-0.4,0.4-0.8 c0.1-0.2,0.2-0.4,0.3-0.5c0,0,0.1-0.1,0.2-0.3c0.2-0.4,0.4-0.6,0.4-0.6c0.1-0.1,0.2-0.3,0.4-0.6c0.2-0.3,0.3-0.4,0.3-0.4 c0.1-0.2,0.3-0.4,0.5-0.7c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.1,0.2,0c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0s0.1,0,0.1,0s0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1c0,0.2,0,0.3,0,0.3c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.1 c0,0,0,0.1,0,0.2c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1-0.1,0.2s0,0.1,0,0.2 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1l0,0.1c0,0.2-0.1,0.3-0.1,0.3c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.3 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2l-0.1,0.3c0,0,0,0.1,0,0.2s0,0.1,0,0.2c0,0,0,0.1-0.1,0.3c0,0.1,0,0.1,0,0.1 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2c0,0,0,0.1,0,0.1 c0,0.2-0.1,0.3-0.1,0.3c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.2-0.1,0.4c0,0,0,0,0,0.1s0,0,0,0.1c0,0,0,0,0,0.1 c0,0.1,0,0.2,0,0.2c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.2c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0.1,0,0.3-0.1,0.4c0,0,0,0.1,0,0.2l-0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2s0,0.1-0.1,0.2c0,0,0,0.1,0,0.2 s0,0.1,0,0.2c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.1,0.3c-0.1,0.1-0.1,0.2-0.3,0.3c-0.1,0-0.1,0-0.1,0l-0.2,0.1c0,0,0,0-0.1,0 c0,0,0,0,0-0.1c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0,0-0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0l0-0.1c0,0.1-0.1,0.1-0.2,0.1 c0,0,0,0,0,0.1h0c0,0,0,0,0,0c0,0,0,0,0,0h-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.2 c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.1,0.1-0.2s0-0.2,0.1-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.2s0-0.1,0.1-0.2c0,0,0-0.1,0-0.2s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2 s0-0.1,0-0.2c0-0.1,0-0.1,0-0.2l0.1-0.5c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1 s0-0.1,0-0.1s0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.2s0-0.2,0-0.2c0,0,0-0.1,0.1-0.2c0-0.1,0-0.2,0-0.2 c0,0,0-0.1,0.1-0.2c0-0.1,0-0.2,0.1-0.2c0,0,0-0.1,0.1-0.2c0-0.1,0-0.2,0.1-0.2c0-0.1,0-0.1,0.1-0.2s0-0.2,0.1-0.2c0,0,0-0.1,0-0.2 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0.1-0.3c0,0,0-0.1,0-0.1s0-0.1,0.1-0.2c0,0,0-0.1,0.1-0.3h0c-0.1,0.2-0.1,0.3-0.1,0.3 s-0.1,0.1-0.2,0.3c-0.1,0.2-0.2,0.4-0.2,0.5c-0.1,0.2-0.1,0.3-0.2,0.6c0,0.1-0.1,0.2-0.2,0.4c-0.1,0.3-0.2,0.5-0.2,0.6 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1s0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1-0.1,0.2 s0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2s-0.1,0.2-0.1,0.2c0,0,0,0.1-0.1,0.2c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.1,0.4-0.2,0.6 c-0.1,0.4-0.2,0.6-0.3,0.8c-0.1,0.1-0.1,0.3-0.2,0.5c-0.1,0.1-0.2,0.1-0.3,0.1h-0.1c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2,0l-0.1,0.1 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0s0,0-0.1,0 c0,0,0,0-0.1,0v0c0,0-0.1,0-0.1,0C93,28.6,93,28.5,93,28.4c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4c0-0.1,0-0.2,0-0.3 c0-0.4,0-0.9,0-1.4c0-0.1,0-0.4,0-0.6c0-0.3,0-0.5,0-0.6c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.3s0-0.2,0-0.3c0-0.1,0-0.3,0-0.3 c0-0.1,0-0.2,0-0.4c0-0.2,0-0.3,0-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2c0-0.3,0-0.5,0-0.8c0-0.1,0-0.2,0-0.4 c0-0.2,0-0.3,0-0.4c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.3c0,0,0,0,0,0.1c0,0.1-0.1,0.2-0.1,0.3 c-0.1,0.1-0.1,0.2-0.2,0.4S92.6,21,92.6,21c-0.1,0.2-0.2,0.4-0.3,0.7c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1-0.1,0.2-0.2,0.4 c-0.1,0.2-0.1,0.3-0.1,0.3c0,0,0,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.2s0,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.2c0,0,0,0.1-0.1,0.2 s-0.1,0.1-0.1,0.1c0,0.1-0.1,0.2-0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.2c0,0.1,0,0.2-0.1,0.2c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.2s0,0.2-0.1,0.2c0,0,0,0.1,0,0.1s0,0.1,0,0.1c0,0,0,0.1,0,0.1s0,0.1-0.1,0.1c0,0,0,0.1,0,0.1 c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.2s0,0.1-0.1,0.2c-0.1,0.3-0.2,0.5-0.3,0.8 c-0.1,0.3-0.2,0.6-0.3,0.7c0,0.1-0.2,0.3-0.4,0.7c-0.1,0.1-0.1,0.1-0.2,0h-0.1c0,0-0.1,0-0.1,0c-0.1,0.1-0.1,0.1-0.1,0 c0,0-0.1,0-0.1,0.1s0,0,0,0l0,0c-0.1,0-0.1,0-0.2,0l0,0l0,0l-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0 c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1,0-0.1c0.1-0.2,0.3-0.6,0.5-1c0-0.1,0.1-0.2,0.1-0.4 c0.1-0.4,0.2-0.6,0.2-0.7c0.1-0.2,0.2-0.6,0.3-1c0-0.1,0.1-0.1,0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3 c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.4c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3 c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.1,0.2-0.4,0.3-0.8c0.1-0.3,0.2-0.5,0.2-0.6 c0-0.1,0.1-0.3,0.3-0.7c0.1-0.2,0.1-0.3,0.2-0.4c0-0.1,0.1-0.1,0.1-0.2s0.1-0.2,0.1-0.2c0,0,0.1-0.1,0.1-0.2s0.1-0.2,0.2-0.3 c0.1-0.1,0.2-0.3,0.3-0.5c0.2-0.3,0.3-0.6,0.4-0.7c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.2-0.3,0.4-0.6c0.1-0.1,0.1-0.1,0.2,0 c0.1-0.1,0.1-0.1,0.2-0.1h0c0.1,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0s0,0,0.1,0c0,0,0.1,0,0.1,0s0,0,0.1,0h0.1c0,0,0.1,0,0.1,0 C94.2,17.3,94.3,17.3,94.4,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M104.8,19.4L104.8,19.4L104.8,19.4C104.9,19.5,104.9,19.5,104.8,19.4c0,0.1,0,0.2,0,0.2 c-0.1,0.5-0.2,1.1-0.4,1.8c-0.1,0.5-0.3,1.1-0.5,1.7c-0.1,0.3-0.2,0.7-0.4,1.3c-0.1,0.4-0.2,0.7-0.2,0.8l-0.1,0.4 c-0.2,0.6-0.3,1-0.4,1.3c-0.1,0.3-0.2,0.7-0.3,1.2c0,0.2-0.1,0.3-0.1,0.4c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1 c0,0,0,0,0,0l0,0l-0.1-0.1l-0.3,0.2l-0.1,0c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.1,0.1l0,0l-0.1-0.1l-0.2,0.2l0,0l-0.2,0.2l0,0 c0,0-0.1,0-0.1,0s-0.1,0-0.1,0h0l0,0l0-0.2c0-0.2,0-0.3,0-0.4c0-0.4,0-0.7,0-1c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4-0.1-0.5 c-0.1-0.5-0.3-0.9-0.6-1.3c0,0,0,0,0,0c-0.5,0.8-0.8,1.4-1.1,2l0,0h0c-0.1,0-0.2,0-0.3,0.1l0,0l-0.1,0l-0.3,0.2l0,0l-0.1,0.1 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0h0v-0.1l0,0l0,0c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.2 c-0.1-0.1-0.1-0.2,0-0.3c0.2-0.2,0.3-0.5,0.6-0.8c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.6,0.5-0.8c0,0-0.1-0.1-0.2-0.1l0,0 c-0.1,0-0.2-0.1-0.3-0.2c-0.1,0-0.1,0-0.1-0.1l-0.2-0.1l0-0.1l0.2,0l-0.1-0.1l0.2-0.1c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0 c0.1,0,0.1,0,0.2-0.1c0,0,0.1-0.1,0.2-0.1c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.1,0,0.2,0h0c0.2-0.4,0.4-0.6,0.4-0.7 c0.1-0.2,0.3-0.4,0.5-0.7l0.8-1.1c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.2,0.2-0.3 c0.2-0.3,0.4-0.4,0.5-0.5c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1 c0,0,0,0,0.1,0c0,0,0,0,0.1,0h0h0c0,0,0,0,0,0s0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0.1,0 c0,0,0,0,0,0c0,0,0.1,0,0.2,0C104.8,19.4,104.8,19.4,104.8,19.4z M101.9,25.3c0.2-0.7,0.5-1.7,0.8-2.8l-1.6,2c0,0,0.1,0,0.1,0.1 c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0.1,0.1,0.1,0.1C101.9,25.2,101.9,25.2,101.9,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M108.4,19.9C108.4,19.9,108.4,19.9,108.4,19.9c0.1,0.1,0.1,0.1,0,0.1c-0.1,0-0.2,0.1-0.3,0.1 c0.1,0,0.1,0,0,0.1c0,0,0.1,0,0.1,0.1c0,0,0,0.1-0.1,0.1c-0.1,0-0.2,0-0.2,0.1v0c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.1,0.1h0 c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1c-0.1,0-0.2,0.1-0.4,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0,0,0s0,0,0,0 c0,0,0,0,0.1,0.1c0,0,0,0.1-0.1,0.1c-0.2,0.1-0.5,0.1-0.8,0.1c-0.1,0.1-0.1,0.2-0.2,0.3s-0.1,0.3-0.2,0.5c0,0.2-0.1,0.3-0.1,0.3 c-0.1,0.3-0.3,0.7-0.4,1.1c0,0,0,0,0,0c-0.6,1.6-0.9,2.6-1,2.9c0,0.1-0.2,0.5-0.3,0.9c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1 c0,0,0.1,0,0.1,0c0,0.1-0.1,0.2-0.2,0.3h0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1 c0,0,0,0.1,0,0.1c-0.1,0-0.1,0-0.2,0.1l0,0c0,0,0,0,0,0s0,0,0,0v0v0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0.1 c-0.1,0-0.3,0.1-0.5,0.1c-0.2,0-0.3,0.1-0.4,0.1c-0.2,0-0.3,0-0.3-0.1c0,0,0,0,0-0.1s0,0,0-0.1s0,0,0-0.1c0,0,0,0,0-0.1 c0,0-0.1-0.1-0.2-0.1c0,0,0,0,0-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1s0,0-0.1,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 l-0.1,0c0,0,0,0,0-0.1c0-0.1,0.1-0.1,0.2-0.2c0,0,0.1,0,0.3-0.1c0.2,0,0.3-0.1,0.4-0.1c0.1,0,0.1-0.1,0.2-0.2 c0.3-1.3,0.8-2.7,1.3-4.2c0.1-0.2,0.2-0.6,0.4-1.1c0,0,0,0,0,0c0.1-0.1,0.1-0.3,0.1-0.4c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0 c-0.1,0.1-0.3,0.1-0.4,0.2c0,0,0,0,0,0.1h0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0 c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1s0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0-0.1,0-0.1 c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0,0-0.1-0.1s0,0,0-0.1l0,0c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1 c0.1-0.1,0.5-0.2,1-0.3c0,0,0,0,0,0c0,0,0,0,0,0c0.3-0.1,0.6-0.1,0.9-0.2c0.3,0,0.5-0.1,0.8-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0 s0,0,0.1,0c0,0,0,0.1,0,0.1C108.2,19.9,108.3,19.9,108.4,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M113.7,20.3c0.4,0.3,0.5,0.7,0.3,1.1c-0.1,0.3-0.3,0.6-0.6,0.9c-0.4,0.4-0.9,0.8-1.3,1.1 c-0.2,0.1-0.5,0.2-0.7,0.3c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.2-0.1c0,0,0,0-0.1-0.1c0,0-0.1,0-0.2-0.1c0,0,0,0-0.1-0.1 c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.2c0,0,0-0.1-0.1-0.1l0,0l0-0.1c0.1-0.3,0.3-0.4,0.6-0.3l0.1,0l0,0 c0.5-0.3,1-0.7,1.4-1.2c0.2-0.2,0.3-0.4,0.3-0.6v0c-0.1,0-0.1,0-0.2,0c-0.4,0.1-0.9,0.3-1.3,0.5c-0.8,0.4-1.6,1-2.2,1.6 c-0.3,0.3-0.5,0.7-0.7,1c-0.1,0.2-0.1,0.3-0.1,0.4c0.1,0,0.2,0,0.3,0h0c0.2,0,0.5-0.1,0.8-0.1c0.4-0.1,0.7-0.1,0.9-0.1 c0.2,0,0.6-0.1,1-0.1c0.3,0,0.5,0.1,0.6,0.2c0,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.1 c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2-0.1,0.4-0.3,0.6c-0.4,0.4-0.9,0.8-1.5,1.3c-0.1,0.1-0.2,0.2-0.4,0.3c-0.3,0.2-0.5,0.3-0.6,0.4 c-0.5,0.4-1,0.7-1.5,1c-0.3,0.2-0.6,0.3-0.9,0.6c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0-0.1,0.1-0.1,0.1l-0.2,0.1l0-0.2l-0.1,0v-0.1 c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1l-0.2,0l0.1-0.1c0,0,0,0,0,0s0,0,0,0c0,0,0,0-0.1,0h-0.1l-0.2-0.2l0-0.1l0,0c0,0,0,0,0,0 l-0.2-0.1l0.1-0.1c0,0,0,0,0,0c0.1-0.1,0.1-0.1,0.1-0.1c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.2-0.1,0.3-0.2,0.4-0.2 l0.2-0.1c0.9-0.6,1.6-1,2-1.3c0.7-0.5,1.3-0.9,1.7-1.2h0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c-0.5,0.1-0.8,0.1-1,0.2 c-0.4,0.1-0.8,0.1-1.1,0c-0.2,0-0.3-0.1-0.4-0.2l-0.1-0.1c-0.3-0.2-0.5-0.4-0.6-0.5c-0.4-0.3-0.5-0.7-0.3-1.1 c0.1-0.4,0.3-0.7,0.6-1.1c0.4-0.5,0.9-1,1.5-1.4c0.5-0.3,1-0.6,1.5-0.9c0.5-0.2,0.9-0.4,1.3-0.4c0.4-0.1,0.7,0,0.9,0.2 c0.1,0.1,0.2,0.2,0.4,0.3C113.5,20.3,113.6,20.3,113.7,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M118.9,21.2c0,0,0,0.1,0,0.1s0,0.1,0,0.1c0,0.2,0,0.4,0,0.5c0,0.1,0,0.2,0,0.2 c0,0.4-0.1,0.7-0.1,0.9c-0.1,0.5-0.1,1-0.2,1.4c-0.2,0.8-0.5,1.5-0.9,2.3c-0.3,0.5-0.6,0.9-0.9,1.2c-0.2,0.2-0.4,0.3-0.6,0.4 c-0.1,0-0.3,0.1-0.6,0.2c-0.2,0.1-0.3,0.1-0.4,0.2c-0.2,0.1-0.4,0.1-0.6,0.1c-0.6,0-1-0.2-1.4-0.7c-0.3-0.4-0.4-0.8-0.4-1.3 c0-0.8,0.1-1.5,0.3-2.1c0.2-0.6,0.4-1.1,0.8-1.7c0.3-0.4,0.6-0.8,0.9-1.1c0.2-0.2,0.4-0.4,0.8-0.7c0.2-0.2,0.4-0.3,0.6-0.4 c0.2-0.1,0.4-0.3,0.7-0.3c0.4-0.1,0.7-0.3,1-0.4c0.2-0.1,0.4-0.1,0.5-0.1c0.3,0,0.5,0.2,0.6,0.6c0,0.1,0,0.2,0.1,0.4 C118.9,21.1,118.9,21.2,118.9,21.2z M117.3,22.1c0-0.1,0-0.3,0-0.3c0,0,0,0,0-0.1v0l-0.2,0.1v-0.1l0,0c-0.1,0.1-0.1,0.1-0.1,0.1 c0,0,0,0-0.1,0h0c-0.1,0-0.1,0.1-0.3,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2-0.1l0.1-0.3c0,0-0.1,0.1-0.1,0.1 c-0.2,0.2-0.3,0.5-0.4,0.8c-0.2,0.4-0.3,1-0.3,1.5c0,0.2,0.1,0.6,0.2,0.9c0,0.1,0,0.2,0,0.2l0,0l0,0c0,0,0,0-0.1,0 c-0.1,0.1-0.2,0.1-0.3,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0l0,0c0,0,0,0-0.1,0.1h0c0,0,0,0-0.1,0c-0.1,0-0.2,0.1-0.2,0.1 c-0.1,0.1-0.2,0-0.3,0c-0.2-0.1-0.3-0.3-0.3-0.5c0,0,0,0,0-0.1c0,0,0,0,0,0.1c-0.1,0.4-0.1,0.9-0.2,1.4c0,0.4,0.1,0.7,0.2,1 c0.1,0.2,0.2,0.3,0.4,0.5c0.3,0,0.6-0.1,0.8-0.2c0.4-0.3,0.6-0.5,0.8-0.7c0,0,0,0,0,0c0.4-0.7,0.6-1.4,0.8-2.2 c0.1-0.5,0.2-1,0.2-1.7C117.3,22.8,117.3,22.5,117.3,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M124.9,19.6c0,0.1,0,0.3,0,0.4v0c0,0.2,0,0.4-0.1,0.6c-0.1,0.3-0.1,0.7-0.2,1.2c0,0.1,0,0.2-0.1,0.5 c0,0.2-0.1,0.4-0.1,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0,0.3-0.1,0.3c0,0.1,0,0.2-0.1,0.4c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.3-0.1,0.6 c-0.1,0.4-0.1,0.7-0.2,0.9c0,0.1,0,0.3-0.1,0.6c-0.1,0.3-0.1,0.4-0.1,0.6c-0.1,0.4-0.1,0.7-0.3,1.1c-0.1,0.3-0.2,0.5-0.3,0.7 c-0.1,0.1-0.2,0.2-0.3,0.2c0,0,0,0,0,0c-0.1,0.1-0.3,0.1-0.4,0.2c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.1,0-0.2,0 c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.2-0.2-0.3-0.4c-0.2-0.4-0.3-0.7-0.4-0.9c-0.2-0.5-0.5-1.3-0.7-2.3c0,0,0,0,0-0.1 l-0.1,0.2c-0.4,1.2-0.7,2-1,2.6v0h0c-0.1,0-0.2,0-0.3,0.1l0,0l-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0 c0,0,0,0-0.1,0c0,0-0.1,0-0.2,0.1c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.3,0l0,0v0c0,0,0-0.1,0.1-0.2c0.1-0.1,0.1-0.3,0.1-0.3 c0-0.1,0.1-0.2,0.1-0.3c0.2-0.5,0.3-0.8,0.3-1c0.1-0.4,0.2-0.7,0.3-1.1c0.1-0.5,0.3-1.1,0.4-1.7c0.1-0.3,0.1-0.7,0.2-1.3 c0-0.1,0-0.3,0-0.4c0-0.4,0-0.8,0.1-1.1v0c0-0.2,0.1-0.4,0.2-0.5l0,0l0.1,0.1l0.1-0.1h0.1l0.6-0.3l0,0.1l0.1-0.1l0.1,0l0,0 c0,0,0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0h0l0,0.1l0.2-0.1l0,0l0,0c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4 c0,0.3-0.1,0.5-0.1,0.8c0,0.1-0.1,0.3-0.1,0.3c0,0.1,0,0.4,0,0.7c0,0.3,0.1,0.6,0.2,1.1c0,0.1,0.1,0.4,0.1,0.7 c0,0.2,0.1,0.4,0.1,0.5c0,0.1,0,0.2,0.1,0.3c0,0.2,0.1,0.3,0.1,0.4c0.1,0.3,0.1,0.6,0.2,1c0.1,0.2,0.1,0.4,0.2,0.8l0.1,0.3 c0,0,0,0,0,0.1v0l0-0.2c0.1-0.4,0.1-0.8,0.1-1c0-0.1,0.1-0.4,0.1-1c0.1-0.7,0.2-1.3,0.2-1.6l0.1-0.4c0-0.4,0.1-0.7,0.1-0.9 c0-0.1,0-0.3,0.1-0.5c0-0.2,0-0.3,0-0.4v0l0-0.1l0,0l0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0.1,0 s0,0,0.1,0v0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0-0.1,0.1-0.2c0-0.1,0-0.2,0.1-0.2c0,0,0-0.1,0.1-0.2 c0-0.1,0.1-0.1,0.1-0.1c0,0,0-0.1,0.1-0.3c0.1-0.2,0.1-0.3,0.2-0.4c0,0,0.1,0,0.1,0s0,0,0,0c0,0.1,0,0.1,0,0.2 c0-0.1,0.1-0.2,0.1-0.2c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1,0 c0.1,0.1,0.1,0.2,0,0.4c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0.2,0,0.4,0,0.6c0-0.1,0.1-0.1,0.1-0.3 c0.1-0.1,0.1-0.2,0.1-0.2C124.8,19.6,124.8,19.6,124.9,19.6C124.9,19.6,124.9,19.6,124.9,19.6z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.3,41.1l0,0.5h0c0.1-0.1,0.2-0.1,0.3-0.1c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.4h0.2 c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3c-0.1,0-0.3,0.1-0.3,0.2l-0.2,0l0.1-0.9H83v0.2H82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,41.6c0,0.5-0.2,0.8-0.6,0.8c-0.4,0-0.6-0.3-0.6-0.8c0-0.5,0.2-0.8,0.6-0.8C84.2,40.8,84.4,41.1,84.4,41.6z  M83.5,41.6c0,0.4,0.1,0.6,0.3,0.6c0.2,0,0.3-0.2,0.3-0.6c0-0.4-0.1-0.6-0.3-0.6C83.6,41,83.5,41.2,83.5,41.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.6,41.6c0,0.5-0.2,0.8-0.6,0.8c-0.4,0-0.6-0.3-0.6-0.8c0-0.5,0.2-0.8,0.6-0.8C99.4,40.8,99.6,41.1,99.6,41.6z  M98.7,41.6c0,0.4,0.1,0.6,0.3,0.6c0.2,0,0.3-0.2,0.3-0.6c0-0.4-0.1-0.6-0.3-0.6C98.9,41,98.7,41.2,98.7,41.6z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.1,42.4v-1.1h-0.3v-0.2c0.2,0,0.3-0.1,0.4-0.3h0.2v1.5H66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,41.6c0,0.5-0.2,0.8-0.6,0.8c-0.4,0-0.6-0.3-0.6-0.8c0-0.5,0.2-0.8,0.6-0.8C67.8,40.8,68,41.1,68,41.6z M67.1,41.6 c0,0.4,0.1,0.6,0.3,0.6c0.2,0,0.3-0.2,0.3-0.6c0-0.4-0.1-0.6-0.3-0.6C67.2,41,67.1,41.2,67.1,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3,41.6c0,0.5-0.2,0.8-0.6,0.8c-0.4,0-0.6-0.3-0.6-0.8c0-0.5,0.2-0.8,0.6-0.8C69.1,40.8,69.3,41.1,69.3,41.6z  M68.4,41.6c0,0.4,0.1,0.6,0.3,0.6c0.2,0,0.3-0.2,0.3-0.6c0-0.4-0.1-0.6-0.3-0.6C68.5,41,68.4,41.2,68.4,41.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.2,
    y: 42.8,
    transform: "matrix(0.9684 -0.2493 0.2493 0.9684 -9.3854 13.9618)",
    style: {
      fill: "#DBDBDB"
    },
    width: 2.6,
    height: 2.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.3,
    y: 47.8,
    transform: "matrix(0.2954 -0.9554 0.9554 0.2954 -15.4324 77.152)",
    style: {
      fill: "#DBDBDB"
    },
    width: 2.6,
    height: 2.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M59.8,51.6c-0.2,0.9-0.4,1.7-0.8,2.4l-1.7-0.4l0.6-2.5L59.8,51.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M59.2,46.9L57.9,48l-1.7-1.9l1.5-1.3c0.1,0.1,0.2,0.1,0.3,0.2C58.5,45.5,58.9,46.2,59.2,46.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M48,56.5l-1.1,1.7c-0.4-0.3-0.9-0.5-1.3-0.9c-0.2-0.3-0.5-0.6-0.7-0.9l0.9-1.3L48,56.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M112.9,57.6l-0.9,1.2c-0.8-0.3-1.6-0.7-2.3-1.2l1.2-1.5L112.9,57.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 117.8,
    y: 44.7,
    transform: "matrix(0.6155 -0.7881 0.7881 0.6155 9.5677 111.538)",
    style: {
      fill: "#DBDBDB"
    },
    width: 2.6,
    height: 2.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M124,51c0,0.6-0.1,1.1-0.2,1.7l-0.5,0.1l-1.5,0.1l-0.3-2.5l1.3-0.1l1-0.1C124,50.4,124,50.7,124,51z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M108.3,52.6l-1.7,0.2c-0.1-0.6-0.2-1.2-0.2-1.8c0-0.3,0-0.5,0-0.8l1.6-0.2L108.3,52.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.1,
    y: 44,
    transform: "matrix(0.5376 0.8432 -0.8432 0.5376 89.6711 -72.9829)",
    style: {
      fill: "#DBDBDB"
    },
    width: 2.6,
    height: 2.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M120.8,57.6c-0.7,0.5-1.5,0.9-2.3,1.2l-0.9-1.4l2.2-1.4L120.8,57.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 130.6,
    y: 43.4,
    style: {
      fill: "#FCF9EE"
    },
    width: 4.5,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 130.6,
    y: 49.3,
    style: {
      fill: "#FCF9EE"
    },
    width: 4.5,
    height: 4.5
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.1,42.7C135.1,42.8,135.1,42.8,135.1,42.7C135.1,42.8,135.1,42.8,135.1,42.7c0,0.1,0,0.1,0,0.1c0,0,0,0-0.1,0 c0,0-0.1,0.1-0.1,0.1s-0.1,0.1-0.2,0.2c0,0-0.1,0.1-0.2,0.2s-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0,0,0 c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 l-0.2,0.3c0,0,0,0-0.1,0.1s-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0,0.1c0.1,0.2,0.1,0.3,0.2,0.4 c0,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.2c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.1 c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0.1s0,0.1,0,0.1c0,0.1,0.1,0.1,0.1,0.2 c0,0,0.1,0.1,0.1,0.2c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0,0,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0 c0,0,0,0,0,0h0c0,0,0,0,0,0s0,0,0,0v0c0,0,0,0,0,0.1c0,0,0,0-0.1,0l0,0c0,0-0.1,0-0.1,0.1c0,0,0,0-0.1-0.1s-0.1-0.1-0.1-0.1 c0,0,0,0-0.1,0.1c-0.1-0.1-0.2-0.2-0.2-0.2c0,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.1-0.2 c0-0.1-0.1-0.2-0.2-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.3-0.2-0.4c0,0-0.1-0.1-0.1-0.2c-0.1,0.2-0.2,0.3-0.2,0.3 c0,0,0,0.1-0.1,0.1s0,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1 s-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.2s-0.1,0.2-0.1,0.2c0,0-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.2,0.3 c0,0,0,0-0.1,0.1c-0.1,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1 c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.1,0-0.1 c0.1-0.1,0.1-0.2,0.1-0.2c0-0.1,0.1-0.2,0.3-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.1 c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.2 c0.1-0.1,0.1-0.2,0.2-0.2c0,0,0.1-0.1,0.1-0.1s0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1 c0-0.1-0.1-0.2-0.1-0.4c0-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1 c0-0.2-0.1-0.3-0.1-0.4c0-0.1,0-0.1-0.1-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1 c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1 c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0.1,0.1,0.2s0,0.1,0.1,0.2c0,0,0,0.1,0.1,0.2c0,0,0,0.1,0,0.1 c0,0.1,0,0.1,0.1,0.2c0,0.1,0,0.2,0.1,0.3c0,0.1,0,0.1,0.1,0.3c0,0,0,0,0,0c0,0,0,0,0.1-0.1c0,0,0,0,0.1-0.1c0,0,0,0,0.1-0.1 c0-0.1,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.3,0.5-0.6c0.1-0.1,0.2-0.2,0.3-0.4c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.2 c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1C135,42.7,135,42.7,135.1,42.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.3cef8fb0505e961a882485f663c4b3eb.svg";
export { ForwardRef as ReactComponent };